/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import "../App.css";
import ToggleSwitchBtn from "./toggleSwitchBtn";
import ReactHtmlParser from "react-html-parser";
import secondsToTimestamp from "seconds-to-timestamp";
import ImagePickerAndViewer from "./imagePickerAndViewer";
import { changeActiveStatusExamset } from "../Action/courseAction";
import DeletePopup from "./deletePopup";
import { renderCorrectAns, renderQuestions } from "../Utils/utils";
import moment from "moment";
import { Chip, IconButton, Tooltip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useSelector } from "react-redux";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Button } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
function AdminTable({
  tableData,
  tableHead,
  handleEdit,
  handleEditBatch,
  handleViewMore,
  handleDelete,
  pagename,
  edit,
  addOnButton,
  type,
  className,
  handleAddOnButton,
  addOnButtonLabel,
  handleCheck,
  adddeleteButton,
  handleStatus,
  totalExpectDuration,
  handleRefund,
  courseTypeList,
  handleEditDuration,
  transactionType,
  totalRevenue,
  ids,
  status,
  panelType,
  showAction,
}) {
  const dispatch = useDispatch();
  const [deletePopup, setDeletePopup] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const [isCopy, setIsCopy] = useState(false);
  const { role } = useSelector((state) => ({
    role: state?.Auth?.userInfo?.role,
  }));

  const copyClassScheduleId = async (value) => {
    try {
      await navigator.clipboard.writeText(value);
      setIsCopy(true);
      setTimeout(() => {
        setIsCopy(false);
      }, 2000);
    } catch (err) {}
  };

  const getSubCategories = (subCategories) => {
    var categoryArray = subCategories
      .map((item) => {
        return item.name;
      })
      .join(", ");
    return <td className="col-2">{categoryArray}</td>;
  };

  const getSMBookList = (courses) => {
    var BookListArray = courses
      ?.map((item) => {
        return item?.booksList
          ?.map((subItem) => {
            return subItem.name;
          })
          .join(", ");
      })
      .join(", ");
    return <td className="col-2">{BookListArray}</td>;
  };

  function getHoursAndMinutesDifference(date1, date2) {
    // Difference in milliseconds
    var difference = Math.abs(date2 - date1);
    var days = Math.floor(difference / (1000 * 60 * 60 * 24));
    // Convert milliseconds to hours and minutes
    var hours = Math.floor(difference / 3600000); // 1 hour = 3600000 milliseconds
    var minutes = Math.floor((difference % 3600000) / 60000); // 1 minute = 60000 milliseconds

    return { hours, minutes, days };
  }

  const DEFICIT = (d1, d2) => {
    const dt1 = new Date(d1);
    const dt2 = new Date(d2);
    const dataTime = getHoursAndMinutesDifference(dt1, dt2);
    const { hours, minutes } = dataTime;
    const hourUpdate = hours > 9 ? hours : "0" + hours;
    const minuteUpdate = minutes > 9 ? minutes : "0" + minutes;
    const sign = dt1 < dt2 ? "-" : "+";
    return (
      <td className="col-2">
        {sign + hourUpdate + ":" + minuteUpdate + ":00"}
      </td>
    );
  };

  const getSMBookType = (courses) => {
    var BookTypeArray = courses
      ?.map((item) => {
        return item.packageName;
      })
      .join(", ");
    return <td className="col-2">{BookTypeArray}</td>;
  };

  const getTrackingIdList = (trackingIdList) => {
    if (trackingIdList?.length > 0) {
      var TrackingIdArray = trackingIdList
        ?.map((subItem) => {
          return subItem.trackingId;
        })
        .join(", ");

      return <td className="col-2">{TrackingIdArray}</td>;
    }
  };

  const changeIntoIst = (date) => {
    date = new Date(date);
    date.setHours(date.getHours() + 5);
    date.setMinutes(date.getMinutes() + 30);
    return date;
  };

  const getBatchNames = (batchNames) => {
    var batchArray = batchNames
      .map((item) => {
        return item?.name
          ? item?.name
          : item?.fromDate
            ? item?.fromDate
            : item?.sessionDate;
      })
      .join(", ");
    return <td className="col-2">{batchArray}</td>;
  };

  const getSessions = (sessions) => {
    var filteredArray = sessions.filter((el) => {
      return el.isSelected;
    });
    var sessionArray = filteredArray
      .map((item) => {
        return item.name;
      })
      .join(", ");
    return <td className="col-2">{sessionArray}</td>;
  };

  const onstatusChanged = (event, examId) => {
    const postData = {
      examId: examId,
      isActive: event?.target?.checked ? event?.target?.checked : false,
    };
    dispatch(
      changeActiveStatusExamset(
        postData,
        () => {},
        () => {},
      ),
    );
  };

  const getSeconds = (minutes) => {
    let seconds = minutes * 60;

    return <td className="col-2">{secondsToTimestamp(seconds)}</td>;
  };

  const getAuthorName = (authorList) => {
    var authorArray = authorList
      .map((item) => {
        return item;
      })
      .join(", ");
    return <td className="col-2">{authorArray}</td>;
  };

  const getExamNames = (examData) => {
    var examArray = examData
      .map((item) => {
        if (item?.subExamIds.length > 0) {
          const examName = [item?.examTypesId?.name];
          var subExamArray = item?.subExamIds
            .map((subItem) => {
              return subItem?.name;
            })
            .join(", ");
          return `${examName} - ${subExamArray}`;
        } else {
          return `${item?.examTypesId?.name}`;
        }
      })
      .join(",\n");
    return <td>{examArray}</td>;
  };

  const getDiscountPrice = (priceArray) => {
    let price = 0;
    priceArray.forEach((item) => {
      price = price + item?.couponDiscount;
    });
    return <td className="col-2">{price}</td>;
  };

  const getBatchName = (coursesList) => {
    var coursesArray = coursesList.map((item) => {
      return item?.courseData?.name ? (
        <ul className="ps-3">
          <li>
            {item?.courseData?.name} <br />
          </li>
        </ul>
      ) : null;
    });
    return coursesArray;
  };

  const getSubscriptionMonths = (coursesList) => {
    var coursesArray = coursesList.map((item) => {
      return item?.subscriptionPlanMonths ? (
        <>
          {item?.subscriptionPlanMonths} <br />
        </>
      ) : null;
    });
    return <td className="col-1">{coursesArray}</td>;
  };

  const getTotalPriceForTotalRevenue = (coursesList) => {
    var coursesArray = coursesList.map((item) => {
      if (item?.sectionType === 1) {
        return item?.actual_Amount ? (
          <>
            {"\u20B9"}
            {item?.taxFreeAmount + item?.actual_Amount + item?.gst_Amount}{" "}
            <br />
            <br />
          </>
        ) : null;
      } else {
        return (
          <>
            {"\u20B9"}
            {item?.taxFreeAmount + item?.actual_Amount + item?.gst_Amount}{" "}
            <br />
            <br />
          </>
        );
      }
    });
    return <td className="col-2">{coursesArray}</td>;
  };

  const getActualPrice = (coursesList) => {
    var coursesArray = coursesList.map((item) => {
      return item?.actual_Amount ? (
        <>
          {"\u20B9"}
          {item?.actual_Amount}
          <br />
        </>
      ) : null;
    });
    return <td className="col-3">{coursesArray}</td>;
  };

  const getGSTPrice = (coursesList) => {
    var coursesArray = coursesList.map((item) => {
      return item?.gst_Amount ? (
        <>
          {"\u20B9"}
          {item?.gst_Amount}
          <br />
        </>
      ) : null;
    });
    return <td className="col-3">{coursesArray}</td>;
  };

  const getPublicationTotalPrice = (coursesList) => {
    var coursesArray = coursesList.map((item) => {
      return item?.taxFreeAmount ? (
        <>
          {"\u20B9"}
          {item?.taxFreeAmount} <br />
        </>
      ) : null;
    });
    return <td className="col-2">{coursesArray}</td>;
  };

  const getEdutechTotalPrice = (coursesList) => {
    var coursesArray = coursesList.map((item) => {
      return item?.taxableAmount ? (
        <>
          {"\u20B9"}
          {item?.taxableAmount} <br />
        </>
      ) : null;
    });
    return <td className="col-2">{coursesArray}</td>;
  };

  const getEdutechSumPrice = (coursesList) => {
    var coursesArray = coursesList.map((item) => {
      return item?.taxableAmount ? (
        <>
          {"\u20B9"}
          {item?.taxFreeAmount + item?.actual_Amount + item?.gst_Amount} <br />
        </>
      ) : null;
    });
    return <td className="col-2">{coursesArray}</td>;
  };

  const getCoupon = (coursesList) => {
    var coursesArray = coursesList.map((item) => {
      return item?.couponName ? (
        <>
          {item?.couponName}
          <br />
        </>
      ) : null;
    });
    return <td className="col-2">{coursesArray}</td>;
  };

  const getDiscountedValue = (coursesList) => {
    const coursesArray = coursesList.map((item, index) => {
      if (!item?.couponDiscount) return null;

      const value = Number(item.couponDiscount);

      return <div key={index}>₹{value.toFixed(2)}</div>;
    });

    return <td className="col-2">{coursesArray}</td>;
  };

  const getTotalPriceSum = (priceArray) => {
    let price = 0;
    priceArray.forEach((item) => {
      price = price + item?.taxableAmount;
    });
    return <td className="col-2">{price}</td>;
  };

  const getPublicationDiscountPrice = (priceArray) => {
    var coursesArray = priceArray.map((item) => {
      return item?.taxFreeAmount ? (
        <>
          {"\u20B9"}
          {item?.booksPrice - item?.taxFreeAmount} <br />
        </>
      ) : null;
    });
    return <td className="col-2">{coursesArray}</td>;
  };
  const assignWhatsAppChatToLead = (
    contact,
    selectedLeadId,
    customerNumber,
  ) => {
    let wabaNumber = "9699939245";
    let ozonetelContactNo = "9699939245";
    dispatch(
      doubletickAssignChat(
        {
          studentLeadId: selectedLeadId,
          customerNumber: customerNumber,
          assignedUserPhoneNumber: `91${ozonetelContactNo}`,
          reassign: true, //Boolean to assign user even if chat is already assigned
          wabaNumber: `91${wabaNumber}`,
        },
        (res) => {
          if (res?.statusCode === 200) {
            const whatsappURL = `https://web.doubletick.io/conversations/91${wabaNumber}/91${contact}`;
            window.open(whatsappURL, "_blank");
          }
        },
        () => {},
      ),
    );
  };
  return (
    <div className="container-fluid pt-3 pe-0 ps-0 table-responsive">
      <table className="w-100 mb-2 ">
        <thead>
          <tr>
            {tableHead?.map((data, index) => {
              return (
                <th key={index} scope="col">
                  {data}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {Array.isArray(tableData) && tableData.length ? (
            tableData?.map((data, index) => {
              return (
                <>
                  <tr>
                    {pagename === "baseOffer" ? (
                      data?._id ? (
                        <td>
                          <span>
                            <input
                              id={data?._id}
                              className="check"
                              type="checkbox"
                              // value={ids.includes(data?._id)}
                              checked={ids.includes(data?._id)}
                              onChange={() => {
                                handleCheck(data?._id);
                              }}
                            />
                          </span>
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {panelType === 1 ? (
                      <>
                        {status === 1 ? (
                          <>
                            {pagename === "influencerList" ? (
                              data?._id ? (
                                <td>
                                  <span>
                                    <input
                                      id={data?._id}
                                      className="check"
                                      type="checkbox"
                                      value={ids?.some((el) =>
                                        ids.includes(el?._id),
                                      )}
                                      onChange={() => {
                                        handleCheck(data);
                                      }}
                                    />
                                  </span>
                                </td>
                              ) : (
                                <td>-</td>
                              )
                            ) : null}
                          </>
                        ) : null}
                      </>
                    ) : (
                      <>
                        {status === 2 ? (
                          <>
                            {pagename === "influencerList" ? (
                              data?._id ? (
                                <td>
                                  <span>
                                    <input
                                      id={data?._id}
                                      className="check"
                                      type="checkbox"
                                      value={ids?.some((el) =>
                                        ids.includes(el?._id),
                                      )}
                                      onChange={() => {
                                        handleCheck(data);
                                      }}
                                    />
                                  </span>
                                </td>
                              ) : (
                                <td>-</td>
                              )
                            ) : null}
                          </>
                        ) : null}
                      </>
                    )}
                    {pagename === "studyMaterialOrders" ? (
                      data?._id ? (
                        <td>
                          <span>
                            <input
                              id={data?._id}
                              className="check"
                              type="checkbox"
                              checked={data.isSelected}
                              onChange={(data) => {
                                handleCheck(data, index);
                              }}
                            />
                          </span>
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    <td>{index + 1}</td>
                    {pagename === "counsellorCode" ||
                    pagename === "edutechCounsellorCode" ||
                    pagename === "publicationCounsellorCode" ||
                    pagename === "copyCounsellorCode" ||
                    pagename === "counsellorCouponCode" ||
                    pagename === "publiCounsellorCode" ||
                    pagename === "publiCounsellorCouponCode" ? (
                      data?.counselorFirstName ? (
                        <td>{data?.counselorFirstName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "srcVideoData" ? (
                      <>
                        <td>
                          {data?.examTypeId ? data?.examTypeId?.name : "-"}
                        </td>
                        <td>
                          {data?.subExamTypeId
                            ? data?.subExamTypeId?.name
                            : "-"}
                        </td>
                        <td>
                          {data?.baseCourseId ? data?.baseCourseId?.name : "-"}
                        </td>
                        <td>
                          {data?.videoCategory
                            ? data?.videoCategory?.name
                            : "-"}
                        </td>
                        <td>{data?.uploadtype === 2 ? "Video" : "Image"}</td>
                        <td>
                          {data?.uploadurl
                            ? data?.uploadurl?.length > 60
                              ? `${data?.uploadurl.slice(0, 60)}..`
                              : data?.uploadurl
                            : "-"}
                        </td>
                      </>
                    ) : null}
                    {pagename === "dummyAccountData" ? (
                      <>
                        <td>
                          {data?.examTypeId ? data?.examTypeId?.name : "-"}
                        </td>
                        <td>
                          {data?.baseCourseId ? data?.baseCourseId?.name : "-"}
                        </td>
                        <td>{data?.type === 2 ? "Instagram" : "Facebook"}</td>
                        <td>{data?.name ? data?.name : "-"}</td>
                        {/* <td>{data?.userName ? data?.userName : "-"}</td> */}
                        {/* <td>{data?.password ? data?.password : "-"}</td> */}
                        <td>{data?.mobileNo ? data?.mobileNo : "-"}</td>
                        <td>{data?.email ? data?.email : "-"}</td>
                      </>
                    ) : null}
                    {pagename === "refundTransactions" ? (
                      <>
                        <td>
                          {moment.utc(data?.orderDate).format("DD-MM-YYYY") ||
                            "-"}
                        </td>
                        <td>{data?.firstName + data?.lastName || "-"}</td>
                        <td>{data?.totalPrice.toFixed(2) ?? 0}</td>
                        <td>{data?.refundAmount.toFixed(2) ?? 0}</td>
                        <td>{data?.reason || "-"}</td>
                        <td>
                          {data?.paymentProof ? (
                            data.paymentProof
                              ?.toLowerCase()
                              ?.endsWith(".pdf") ? (
                              <PictureAsPdfIcon
                                sx={{
                                  fontSize: 25,
                                  color: "#d32f2f",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  window.open(data.paymentProof, "_blank")
                                }
                              />
                            ) : (
                              <VisibilityIcon
                                sx={{
                                  fontSize: 25,
                                  color: "#29bd75",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  handleViewMore(1, data?.paymentProof)
                                }
                              />
                            )
                          ) : (
                            <span>-</span>
                          )}
                        </td>
                        <td>
                          {data?.invoice ? (
                            data.invoice.toLowerCase().endsWith(".pdf") ? (
                              <PictureAsPdfIcon
                                sx={{
                                  fontSize: 25,
                                  color: "#d32f2f",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  window.open(data.invoice, "_blank")
                                }
                              />
                            ) : (
                              <VisibilityIcon
                                sx={{
                                  fontSize: 25,
                                  color: "#29bd75",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleViewMore(1, data?.invoice)}
                              />
                            )
                          ) : (
                            <span>-</span>
                          )}
                        </td>
                        <td>
                          {role === "CXO" && status === 1 && (
                            <div className="d-flex align-items-center gap-2">
                              <Tooltip title="Rejected">
                                <IconButton
                                  onClick={() => handleStatus(data, 3)}
                                >
                                  <CancelIcon color="error" />
                                </IconButton>
                              </Tooltip>

                              <Tooltip title="Approved">
                                <IconButton
                                  onClick={() => handleStatus(data, 2)}
                                >
                                  <CheckCircleIcon color="success" />
                                </IconButton>
                              </Tooltip>
                            </div>
                          )}

                          {role === "CXO" && (status === 2 || status === 4) && (
                            <Tooltip title="View">
                              <IconButton onClick={() => handleStatus(data, 0)}>
                                <VisibilityIcon />
                              </IconButton>
                            </Tooltip>
                          )}

                          {role === "FINANCE" && status === 2 && (
                            <div className="d-flex align-items-center gap-2">
                              {/* <Tooltip title="Rejected">
                                <IconButton
                                  onClick={() => handleStatus(data, 3)}
                                >
                                  <CancelIcon color="error" />
                                </IconButton>
                              </Tooltip> */}

                              <Tooltip title="Approved">
                                <IconButton
                                  onClick={() => handleStatus(data, 4)}
                                >
                                  <CheckCircleIcon color="success" />
                                </IconButton>
                              </Tooltip>
                            </div>
                          )}

                          {role === "FINANCE" && status === 4 && (
                            <Tooltip title="View">
                              <IconButton onClick={() => handleStatus(data, 0)}>
                                <VisibilityIcon />
                              </IconButton>
                            </Tooltip>
                          )}
                        </td>
                      </>
                    ) : null}
                    {pagename === "influencerPayList" ? (
                      <>
                        <td>{data?.refferedUser ? data?.refferedUser : "-"}</td>
                        {data?.orders?.map((itm) => {
                          return (
                            <tr className="bg-transparent">
                              {" "}
                              <td>{itm?.courseName}</td>
                            </tr>
                          );
                        })}
                        <td>
                          {data?.subscribedAmount ?? data?.subscribedAmount}
                        </td>
                        <td>{data?.referralAmount ?? data?.referralAmount}</td>
                        <td>
                          {data?.status === 1
                            ? "Pending"
                            : data?.status === 2
                              ? "Approved"
                              : data?.status === 3
                                ? "Paid"
                                : "Rejected"}
                        </td>
                      </>
                    ) : null}
                    {pagename === "influencerList" ? (
                      <>
                        <td>
                          {data?.referredUserId
                            ? `${data?.referredUserId?.firstName} ${data?.referredUserId?.lastName}`
                            : "-"}
                        </td>
                        {data?.orders?.map((itm) => {
                          return (
                            <tr className="bg-transparent">
                              <td>{itm?.coursesName}</td>
                            </tr>
                          );
                        })}

                        <td>
                          {data?.userReferCode ? data?.userReferCode : "-"}
                        </td>
                        <td>
                          {data?.subscribedAmount ?? data?.subscribedAmount}
                        </td>
                        <td>{data?.referralAmount ?? data?.referralAmount}</td>
                      </>
                    ) : null}
                    {pagename === "incentiveRevenue" ? (
                      <>
                        <td>
                          {data?.FirstName} {data?.LastName}
                        </td>
                        <td>{data?.couponName ? data?.couponName : "-"}</td>
                        <td>
                          {data?.withoutGstTotal ? data?.withoutGstTotal : "-"}
                        </td>
                        <td>
                          {data?.withGstAmountTotal
                            ? data?.withGstAmountTotal
                            : "-"}
                        </td>
                        <td>{data?.courseNames ? data?.courseNames : "-"}</td>
                      </>
                    ) : null}
                    {pagename === "AddOnAnalysis" ? (
                      <>
                        <td className=" text-center">
                          {moment.utc(data?.orderDate).format("DD-MM-YYYY") ||
                            "-"}
                        </td>
                        <td className=" text-center">
                          {data?.totalOrders || "0"}
                        </td>
                        <td className=" text-center">
                          {data?.totalAddOnCount || "0"}
                        </td>
                        <td className=" text-center">
                          {data?.totalCourses || "0"}
                        </td>
                        <td className=" text-center">
                          {data?.totalPopUpCount || "0"}
                        </td>
                        <td className=" text-center">
                          {data?.totalCartCount || "0"}
                        </td>
                        <td className=" text-center">
                          {data?.upgradeOptionFalse || "0"}
                        </td>
                        <td className=" text-center">
                          {data?.addOnRatio || "0"}
                        </td>
                        <td className=" text-center">
                          {data?.dayConversion || "0"}
                        </td>
                      </>
                    ) : null}
                    {pagename === "CrossSellingAnalysis" ? (
                      <>
                        <td className=" text-center">
                          {moment.utc(data?.orderDate).format("DD-MM-YYYY") ||
                            "-"}
                        </td>
                        <td className=" text-center">
                          {data?.newOrders || "0"}
                        </td>
                        <td className=" text-center">
                          {data?.totalOrders || "0"}
                        </td>
                        <td className=" text-center">
                          {data?.totalCrossSellingOrders || "0"}
                        </td>
                        <td className=" text-center">
                          {data?.uniqueUsers || "0"}
                        </td>
                        <td className=" text-center">
                          {data?.crossSellingRation || "0"}
                        </td>
                        <td className=" text-center">
                          {data?.totalDayConversion || "0"}
                        </td>
                      </>
                    ) : null}
                    {pagename === "CancelledAnalysis" ? (
                      <>
                        <td className=" text-center">
                          {moment.utc(data?.date).format("DD-MM-YYYY") || "-"}
                        </td>
                        <td className=" text-center">
                          {data?.totalCoupons || "0"}
                        </td>
                        <td className=" text-center">
                          {data?.totalPayments || "0"}
                        </td>
                        <td className=" text-center">
                          {data?.couponUsed || "0"}
                        </td>
                        <td className=" text-center">
                          {data?.couponConversion || "0"}
                        </td>
                      </>
                    ) : null}
                    {pagename === "inventoryManagement" ? (
                      <>
                        <td>{data?.company ? data?.company?.name : "0"}</td>
                        <td>{data?.asset ? data?.asset?.name : "0"}</td>
                        <td>
                          {data?.deviceModel ? data?.deviceModel?.name : "0"}
                        </td>
                        <td>
                          {data?.deviceLabelNo ? data?.deviceLabelNo : "0"}
                        </td>
                        <td>
                          {data?.deviceSerialNo ? data?.deviceSerialNo : "0"}
                        </td>
                        <td>
                          {data?.purchesDate
                            ? moment(data?.purchesDate).format("DD-MM-YYYY")
                            : "-"}
                        </td>
                        <td>
                          {data?.status
                            ? data?.status === 1
                              ? "Available"
                              : data?.status === 2
                                ? "Assigned"
                                : data?.status === 3
                                  ? "Damaged"
                                  : data?.status === 4
                                    ? "Repair"
                                    : data?.status === 5
                                      ? "Dead"
                                      : data?.status === 6
                                        ? "Office Use"
                                        : data?.status === 7
                                          ? "Studio Use"
                                          : ""
                            : "-"}
                        </td>
                      </>
                    ) : null}
                    {pagename === "teacherLecture" ? (
                      data ? (
                        <>
                          <td>{data?.title ? data?.title : "-"}</td>
                          <td>
                            {data?.examTypeId?.name
                              ? data?.examTypeId?.name
                              : "-"}
                          </td>
                          <td>
                            {data?.subExamTypeId?.name
                              ? data?.subExamTypeId?.name
                              : "-"}
                          </td>
                          <td>
                            {data?.baseCourseId?.name
                              ? data?.baseCourseId?.name
                              : "-"}
                          </td>
                          <td>
                            {data?.teacherId?.name
                              ? data?.teacherId?.name
                              : "-"}
                          </td>
                          <td>{data?.order ? data?.order : "-"}</td>
                        </>
                      ) : (
                        <>
                          <td>-</td>
                          <td>-</td>
                          <td>-</td>
                          <td>-</td>
                          <td>-</td>
                        </>
                      )
                    ) : null}
                    {pagename === "ParentCourse" ||
                    pagename === "ExamName" ||
                    pagename === "SubExam" ||
                    pagename === "Language" ||
                    pagename === "subCatagory1" ||
                    pagename === "subCatagory2" ||
                    pagename === "subCatagory3" ||
                    pagename === "subCatagory4" ||
                    // pagename === "subject" ||
                    pagename === "books" ||
                    pagename === "assignbooks" ||
                    pagename === "maincategory" ||
                    pagename === "section" ||
                    pagename === "assignUnit" ||
                    pagename === "teacher" ||
                    pagename === "couponCode" ||
                    pagename === "edutechCounsellorCode" ||
                    pagename === "publicationCounsellorCode" ||
                    pagename === "copyCounsellorCode" ||
                    pagename === "topic" ||
                    pagename === "subTopic" ||
                    pagename === "liveRecordedVideo" ||
                    pagename === "package" ||
                    pagename === "packageExtend" ||
                    pagename === "jobType" ||
                    pagename === "counsellorCode" ||
                    pagename === "counsellorCouponCode" ||
                    pagename === "publiCounsellorCode" ||
                    pagename === "publiCounsellorCouponCode" ||
                    pagename === "SopPpt" ||
                    pagename === "referenceLeadCount" ||
                    pagename === "referenceTeamLeadCount" ||
                    pagename === "designations" ||
                    pagename === "company" ||
                    pagename === "department" ||
                    pagename === "lecture" ? (
                      data?.name ? (
                        <td>{data?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "subject" ? (
                      data?.name ? (
                        <td>{data?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "subject" || pagename === "topic" ? (
                      data?.order ? (
                        <td>{data?.order}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "SubExam" ? (
                      data?.file ? (
                        <td>
                          <img
                            htmlFor="photo-upload"
                            src={data?.file}
                            style={{ width: "40px", height: "40px" }}
                            alt={""}
                          />
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "SubExam" ? (
                      data?.seoName ? (
                        <td>{data?.seoName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "SubExam" ? (
                      data?.order != null ? (
                        <td>{data?.order}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "editLivePremierVideo" ||
                    pagename === "editLiveVideo" ? (
                      data?.title ? (
                        <td>{data?.title}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "editLiveFreeVideo" ? (
                      data?.lectureTitle ? (
                        <td>{data?.lectureTitle}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "editLiveFreeVideo" ? (
                      data?.sessionsData ? (
                        <td>{data?.sessionsData?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "editLiveVideo" ||
                    pagename === "editLivePremierVideo" ? (
                      data?.sessionId ? (
                        <td>{data?.sessionId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "editLivePremierVideo" ||
                    pagename === "editLiveFreeVideo" ? (
                      data?.teachersData ? (
                        <td>{data?.teachersData.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "editLiveVideo" ? (
                      data?.teacherId ? (
                        <td>{data?.teacherId.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "editLivePremierVideo" ||
                    pagename === "editLiveFreeVideo" ? (
                      data?.mettingId?.length > 0 ? (
                        <td>{data?.mettingId[0].email}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "editLiveVideo" ? (
                      data?.mettingId ? (
                        <td>{data?.mettingId.email}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "editLivePremierVideo" ||
                    pagename === "editLiveFreeVideo" ||
                    pagename === "editLiveVideo" ? (
                      type === 1 || type === 3 ? (
                        <td>
                          {data?.isRTMPEnvironment
                            ? "RTMP"
                            : data?.isJitsiEnvironment
                              ? "JitSi"
                              : "BBB"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "editLiveVideo" ? (
                      data?.classSchedule ? (
                        <td>
                          {`${data?.classSchedule[0]?.fromDate} -
                            ${
                              data?.classSchedule[
                                data?.classSchedule?.length - 1
                              ]?.toDate
                            }`}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "editLiveVideo" ? (
                      data?.createdAt ? (
                        <td>
                          {moment(data?.createdAt).format(
                            "DD-MM-YYYY hh:mm:ss",
                          )}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "onboardingForm" ? (
                      <>
                        <td>
                          {data?.firstName
                            ? data?.firstName.toUpperCase()
                            : "-"}
                        </td>
                        <td>
                          {data?.lastName ? data?.lastName.toUpperCase() : "-"}
                        </td>
                        <td>{data?.designation ? data?.designation : "-"}</td>
                      </>
                    ) : null}
                    {pagename === "editQuestionBank" ? (
                      data?.lecture?.name ? (
                        <td>{data?.lecture?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "questionOftheDay" ? (
                      data?.questionDate ? (
                        <td className="col-md-2">
                          {moment
                            .utc(data?.questionDate)
                            .format("DD-MM-YYYY") || "-"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "quizOftheDay" ? (
                      data?.startDate ? (
                        <td className="col-md-2">
                          {moment.utc(data?.startDate).format("lll") || "-"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}

                    {pagename === "quizOftheDay" ? (
                      data?.topicName ? (
                        <td className="">{data?.topicName || "-"}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "editQuestion" ||
                    pagename === "questionOftheDay" ||
                    pagename === "viewQuestion" ? (
                      data?.en?.title ? (
                        <td>{renderQuestions(data?.en?.title)}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "editQuestionBank" ? (
                      data?.en?.title ? (
                        <td>
                          {data?.en?.title?.map((value) => {
                            return (
                              <>
                                {value?.descType === "text" ? (
                                  <>{ReactHtmlParser(value?.description)}</>
                                ) : null}

                                {value?.descType === "img" ? (
                                  <ImagePickerAndViewer
                                    lableName={"Image"}
                                    value={value?.description}
                                    removelabel={true}
                                    disabled
                                  />
                                ) : null}
                              </>
                            );
                          })}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "editQuestion" ||
                    pagename === "editQuestionBank" ||
                    pagename === "questionOftheDay" ||
                    pagename === "viewQuestion" ? (
                      <td className="fw-bold">
                        {data?.questionType === 1 ? (
                          renderCorrectAns(data?.en?.options)
                        ) : data?.questionType === 2 ? (
                          renderCorrectAns(data?.en?.options)
                        ) : (
                          <>
                            {data?.range?.r1} {data?.range?.r2}
                          </>
                        )}
                      </td>
                    ) : null}
                    {/* {pagename === "editQuestion" ||
                    pagename === "editQuestionBank" ? (
                      data?.en?.options?.length > 0 && data?.range?.r1 >= 0 ? (
                        <td>
                          {data?.range?.r1} {data?.range?.r2}
                        </td>
                      ) : data?.questionType === 3 ? (
                        <td className="fw-bold">
                          {ReactHtmlParser(data?.en?.ansDescription?.text)}
                        </td>
                      ) : (
                        <td className="fw-bold">
                          {renderCorrectAns(data?.en?.options)}
                        </td>
                      )
                    ) : null} */}
                    {pagename === "editQuestionBank" ? <td>-</td> : null}
                    {pagename === "question" || pagename === "examSet" ? (
                      data?.en || data?.name ? (
                        <td>{data?.en?.name ? data?.en?.name : data?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "question" || pagename === "examSet" ? (
                      data?.totalQuestions >= 0 &&
                      data?.totalAddedQuestion >= 0 ? (
                        <td>
                          {data?.totalAddedQuestion}/{data?.totalQuestions}
                        </td>
                      ) : (
                        <td>0/0</td>
                      )
                    ) : null}
                    {pagename === "question" ? (
                      data?.isSectionWise || !data?.isSectionWise ? (
                        <td>{data?.isSectionWise ? "Yes" : "No"}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "package" ? (
                      data?.section ? (
                        <td>{data?.section}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "packageExtend" ||
                    pagename === "packageExtendAndUpgrade" ? (
                      data?.sectionId ? (
                        <td>{data?.sectionId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "teacher" ? (
                      data?.examTypesIds ? (
                        getExamNames(data?.examTypesIds)
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "ParentCourse" ? (
                      data?.expertDetails && data?.expertDetails?.mobileNo ? (
                        <td>{data?.expertDetails?.mobileNo}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "ParentCourse" ? (
                      data?.expertDetails && data?.expertDetails?.message ? (
                        <td>{data?.expertDetails?.message}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* {pagename === "ParentCourse" ? (
                      data?.CRMParentCourse ? (
                        <td>{data?.CRMParentCourse}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null} */}
                    {pagename === "ParentCourse" ? (
                      data?.file ? (
                        <td>
                          <img
                            htmlFor="photo-upload"
                            src={data?.file}
                            style={{ width: "40px", height: "40px" }}
                            alt={""}
                          />
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "ParentCourse" ? (
                      data?.seoName ? (
                        <td>{data?.seoName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "competitor" ? (
                      <>
                        <td>{data?.name}</td>
                      </>
                    ) : null}
                    {pagename === "Language" ? (
                      data?.abbreviation ? (
                        <td>{data?.abbreviation}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "ExamName" ? (
                      data?.file ? (
                        <td>
                          <img
                            htmlFor="photo-upload"
                            src={data?.file}
                            style={{ width: "40px", height: "40px" }}
                            alt={""}
                          />
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* {pagename === "ExamName" ? (
                      data?.crmExamName ? (
                        <td>{data?.crmExamName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null} */}
                    {pagename === "ExamName" ? (
                      data?.seoName ? (
                        <td>{data?.seoName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "ExamName" ? (
                      data?.order != null ? (
                        <td>{data?.order}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "SopPpt" ? (
                      data?.type !== 1 && data?.fullPath ? (
                        <td>
                          <img
                            htmlFor="photo-upload"
                            src={data?.fullPath}
                            style={{ width: "40px", height: "40px" }}
                            alt={""}
                          />
                        </td>
                      ) : (
                        <td className="d-flex">
                          <ImagePickerAndViewer
                            key={"pdf" + index}
                            value={data?.fullPath}
                            htmlFor={"pdf-upload"}
                            doctype={"pdf"}
                            removelabel={true}
                          />
                          <label className="label w-100">
                            {data?.file ? data?.file : ""}
                          </label>
                        </td>
                      )
                    ) : null}
                    {pagename === "Language" ||
                    pagename === "subCatagory1" ||
                    pagename === "subCatagory2" ||
                    pagename === "subCatagory3" ||
                    pagename === "subCatagory4" ? (
                      data?.icon ? (
                        <td>
                          <img
                            htmlFor="photo-upload"
                            src={data?.icon}
                            style={{ width: "30px", height: "30px" }}
                            alt={""}
                          />
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "subCatagory1" ||
                    pagename === "subCatagory2" ||
                    pagename === "subCatagory3" ||
                    pagename === "subCatagory4" ? (
                      data?.isTaxable || !data?.isTaxable ? (
                        <td>{data?.isTaxable ? "Yes" : "No"}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "subCatagory1" ? (
                      data?.time >= 0 ? (
                        <td>
                          {data?.time === 1 ? "Start Date" : "Video Duration"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "subCatagory2" ||
                    pagename === "subCatagory4" ? (
                      data?.sellType >= 0 ? (
                        <td>
                          {data?.sellType === 1
                            ? "Single Book"
                            : data?.sellType === 2
                              ? "Combo Book"
                              : data?.sellType === 3
                                ? "Complete Study Material"
                                : "Without Study Material"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "subCatagory1" ? (
                      data?.classType >= 0 ? (
                        <td>{data?.classType === 1 ? "Live" : "Premier"}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "books" || pagename === "assignbooks" ? (
                      data?.coverImage ? (
                        <td>
                          <img
                            htmlFor="photo-upload"
                            src={data?.coverImage}
                            style={{
                              width: "50px",
                              height: "50px",
                            }}
                            alt={""}
                          />
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "books" || pagename === "assignbooks" ? (
                      data?.price >= 0 ? (
                        <td className="text-center">₹{data?.price}</td>
                      ) : null
                    ) : null}
                    {pagename === "books" ? (
                      <td className="text-center">
                        ₹{data?.printingCost ? data?.printingCost : "-"}
                      </td>
                    ) : null}
                    {pagename === "books" || pagename === "assignbooks" ? (
                      data?.author ? (
                        // <td>{data?.author}</td>
                        getAuthorName(data?.author)
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "books" ? (
                      data?.barcodeUrl ? (
                        <td className="col-2 text-start">
                          {
                            <img
                              src={data?.barcodeUrl}
                              alt="barcode"
                              style={{ height: 50, width: 150 }}
                            />
                          }
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "books" ||
                    pagename === "assignbooks" ||
                    pagename === "package" ||
                    pagename === "packageExtend" ? (
                      data?.language ? (
                        <td>{data?.language?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "books" || pagename === "assignbooks" ? (
                      data?.pdf ? (
                        <td>{data?.pdf !== "" ? "Yes" : "No"}</td>
                      ) : (
                        <td>No</td>
                      )
                    ) : null}
                    {pagename === "books" || pagename === "assignbooks" ? (
                      data?.videoUrl ? (
                        <td>{data?.videoUrl !== "" ? "Yes" : "No"}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "maincategory" ? (
                      data?.isSession || !data?.isSession ? (
                        <td>{data?.isSession === true ? "Yes" : "No"}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "maincategory" ? (
                      data?.hasInstallment || !data?.hasInstallment ? (
                        <td>{data?.hasInstallment === true ? "Yes" : "No"}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "maincategory" ? (
                      data?.isLecture || !data?.isLecture ? (
                        <td>{data?.isLecture === true ? "Yes" : "No"}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "maincategory" ? (
                      data?.primaryTypeId ? (
                        <td>{data?.primaryTypeId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "maincategory" ? (
                      data?.subCategories ? (
                        getSubCategories(data?.subCategories)
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "section" ||
                    pagename === "package" ||
                    pagename === "packageExtend" ? (
                      data?.order ? (
                        <td>{data?.order}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "section" ? (
                      data?.type ? (
                        <td>
                          {data?.type === 1
                            ? "Course"
                            : data?.type === 2
                              ? "Study Material"
                              : data?.type === 3
                                ? "Test Series"
                                : data?.type === 4
                                  ? "E-books"
                                  : data?.type === 5
                                    ? "Lectures"
                                    : data?.type === 6
                                      ? "Crash Course"
                                      : data?.type === 7
                                        ? "PYQ Course"
                                        : data?.type === 8
                                          ? "Practice Course"
                                          : ""}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "batchType" ? (
                      data?.name ? (
                        <td>{data?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "bannertype" ||
                    pagename === "batchType" ||
                    pagename === "courseType" ? (
                      data?.type ? (
                        <td>{data?.type}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "section" ||
                    pagename === "package" ||
                    pagename === "packageExtend" ? (
                      data?.displayOnHomePage || !data?.displayOnHomePage ? (
                        <td>
                          {data?.displayOnHomePage === true ? "Yes" : "No"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "assignUnit" ? (
                      data?.bannerImage ? (
                        <td>
                          <img
                            htmlFor="photo-upload"
                            src={data?.bannerImage}
                            style={{
                              width: "40px",
                              height: "40px",
                            }}
                            alt={""}
                          />
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "assignUnit" ? (
                      data?.languageId ? (
                        <td>{data?.languageId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "assignUnit" ? (
                      data?.duration ? (
                        <td>
                          {
                            // getSeconds(data?.duration)
                            secondsToTimestamp(data?.duration)
                          }
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "IssueType" ? (
                      data?.name ? (
                        <td>{data?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "IssueType" ? (
                      data?.price ? (
                        <td>{data?.price}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "couponCode" ||
                    pagename === "edutechCounsellorCode" ||
                    pagename === "publicationCounsellorCode" ||
                    pagename === "copyCounsellorCode" ||
                    pagename === "stockManagement" ? (
                      data?.baseCourseId ? (
                        <td>{data?.baseCourseId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "couponCode" ||
                    pagename === "edutechCounsellorCode" ||
                    pagename === "publicationCounsellorCode" ||
                    pagename === "copyCounsellorCode" ||
                    pagename === "stockManagement" ||
                    pagename === "seoExam" ||
                    pagename === "seoSubExam" ||
                    pagename === "productSchema" ? (
                      data?.examTypeId ? (
                        <td>{data?.examTypeId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "couponCode" ||
                    pagename === "edutechCounsellorCode" ||
                    pagename === "publicationCounsellorCode" ||
                    pagename === "copyCounsellorCode" ||
                    pagename === "stockManagement" ||
                    pagename === "seoSubExam" ||
                    pagename === "productSchema" ? (
                      data?.subExamTypeId ? (
                        <td>{data?.subExamTypeId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "seoSubExam" && courseTypeList?.length > 0 ? (
                      data?.courseType ? (
                        <>
                          <td>
                            {
                              courseTypeList.find(
                                (dataNew) => dataNew.type === data?.courseType,
                              )?.name
                            }
                          </td>
                        </>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "dispatchData" ? (
                      data?._id ? (
                        <>
                          <td>
                            {data?.examTypeId?.name
                              ? data?.examTypeId?.name
                              : "-"}
                          </td>
                          <td>
                            {data?.subExamTypeId?.name
                              ? data?.subExamTypeId?.name
                              : "-"}
                          </td>
                          <td>
                            {data?.baseCourseId?.name
                              ? data?.baseCourseId?.name
                              : "-"}
                          </td>
                          <td>{data?.booksCount ? data?.booksCount : "-"}</td>
                          <td>
                            {data?.deliveryCharges
                              ? data?.deliveryCharges
                              : "-"}
                          </td>
                          <td>
                            {data?.deliveryCharges +
                              data?.profitPrice +
                              data?.totalPrintingCost}
                          </td>
                        </>
                      ) : null
                    ) : null}
                    {pagename === "stockAnalysis" ? (
                      <>
                        <td></td>
                      </>
                    ) : null}
                    {pagename === "seoExam" || pagename === "seoSubExam" ? (
                      data?.metaTitle ? (
                        <td>{data?.metaTitle}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "seoExam" || pagename === "seoSubExam" ? (
                      data?.metaDescrition ? (
                        <td>{data?.metaDescrition}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "seoExam" || pagename === "seoSubExam" ? (
                      data?.content ? (
                        <td>{data?.content}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "productSchema" ? (
                      data?.sectionName ? (
                        <td>{data?.sectionName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "productSchema" ? (
                      data?.CourseName ? (
                        <td>{data?.CourseName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "productSchema" ? (
                      data?.rating ? (
                        <td>{data?.rating}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "productSchema" ? (
                      data?.count ? (
                        <td>{data?.count}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "examMapping" ? (
                      <>
                        <td>
                          {data?.toExamTypeName ? data?.toExamTypeName : "-"}
                        </td>
                        <td>
                          {data?.toBaseCourseName
                            ? data?.toBaseCourseName
                            : "-"}
                        </td>
                        <td>
                          {data?.priorityOrder ? data?.priorityOrder : "-"}
                        </td>
                        <td>
                          {data?.isRecommend === true
                            ? "Yes"
                            : data?.isRecommend === false
                              ? "No"
                              : "-"}
                        </td>
                      </>
                    ) : null}
                    {pagename === "departmentMapping" ? (
                      <>
                        <td>
                          {data?.toExamTypeName ? data?.toExamTypeName : "-"}
                        </td>
                        <td>
                          {data?.toBaseCourseName
                            ? data?.toBaseCourseName
                            : "-"}
                        </td>
                      </>
                    ) : null}
                    {pagename === "couponCode" ||
                    pagename === "edutechCounsellorCode" ||
                    pagename === "publicationCounsellorCode" ||
                    pagename === "copyCounsellorCode" ||
                    pagename === "copyCounsellorCode" ||
                    pagename === "package" ||
                    pagename === "packageExtend" ? (
                      data?.mainCategoryId ? (
                        <td>{data?.mainCategoryId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "couponCode" ||
                    pagename === "edutechCounsellorCode" ||
                    pagename === "publicationCounsellorCode" ||
                    pagename === "copyCounsellorCode" ||
                    pagename === "publiCounsellorCode" ||
                    pagename === "publiCounsellorCouponCode" ? (
                      data?.subCategoryId ? (
                        <td>{data?.subCategoryId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "couponCode" ||
                    pagename === "edutechCounsellorCode" ? (
                      data?.subscriptionDurationId ? (
                        <td>{data?.subscriptionDurationId?.months}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "couponCode" ||
                    pagename === "edutechCounsellorCode" ||
                    pagename === "publicationCounsellorCode" ||
                    pagename === "copyCounsellorCode" ||
                    pagename === "package" ||
                    pagename === "packageExtend" ||
                    pagename === "counsellorCode" ||
                    pagename === "counsellorCouponCode" ||
                    pagename === "publiCounsellorCode" ||
                    pagename === "publiCounsellorCouponCode" ? (
                      data?.startDate ? (
                        <td>
                          {data?.status === 0 ? (
                            <span className="fw-bold text-warning">
                              {/* {data?.startDate.slice(0, 10)} */}
                              {moment.utc(data?.startDate).format("DD-MM-YYYY")}
                            </span>
                          ) : data?.status === 1 ? (
                            <span className="fw-bold text-success">
                              {/* {data?.startDate.slice(0, 10)} */}
                              {moment.utc(data?.startDate).format("DD-MM-YYYY")}
                            </span>
                          ) : data?.status === 9 ? (
                            <span className="fw-bold text-danger">
                              {/* {data?.startDate.slice(0, 10)} */}
                              {moment.utc(data?.startDate).format("DD-MM-YYYY")}
                            </span>
                          ) : (
                            ""
                          )}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "couponCode" ||
                    pagename === "edutechCounsellorCode" ||
                    pagename === "publicationCounsellorCode" ||
                    pagename === "copyCounsellorCode" ||
                    pagename === "counsellorCode" ||
                    pagename === "counsellorCouponCode" ||
                    pagename === "publiCounsellorCode" ||
                    pagename === "publiCounsellorCouponCode" ? (
                      data?.endDate ? (
                        <td>
                          {data?.status === 0 ? (
                            <span className="fw-bold text-warning">
                              {/* {data?.endDate.slice(0, 10)} */}
                              {moment.utc(data?.endDate).format("DD-MM-YYYY")}
                            </span>
                          ) : data?.status === 1 ? (
                            <span className="fw-bold text-success">
                              {/* {data?.endDate.slice(0, 10)} */}
                              {moment.utc(data?.endDate).format("DD-MM-YYYY")}
                            </span>
                          ) : data?.status === 9 ? (
                            <span className="fw-bold text-danger">
                              {/* {data?.endDate.slice(0, 10)} */}
                              {moment.utc(data?.endDate).format("DD-MM-YYYY")}
                            </span>
                          ) : (
                            ""
                          )}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "couponCode" ||
                    pagename === "edutechCounsellorCode" ||
                    pagename === "publicationCounsellorCode" ||
                    pagename === "copyCounsellorCode" ||
                    pagename === "counsellorCode" ||
                    pagename === "counsellorCouponCode" ||
                    pagename === "publiCounsellorCode" ||
                    pagename === "publiCounsellorCouponCode" ? (
                      data?.discPer ? (
                        <td>{data?.discPer}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "couponCode" ||
                    pagename === "edutechCounsellorCode" ||
                    pagename === "publicationCounsellorCode" ||
                    pagename === "copyCounsellorCode" ||
                    pagename === "counsellorCode" ||
                    pagename === "publiCounsellorCode" ? (
                      data?.status || data?.status >= 0 ? (
                        <td>
                          {data?.status === 0 ? (
                            <span className="fw-bold text-warning">
                              Deactive
                            </span>
                          ) : data?.status === 1 ? (
                            <span className="fw-bold text-success">Active</span>
                          ) : data?.status === 9 ? (
                            <span className="fw-bold text-danger">Deleted</span>
                          ) : (
                            ""
                          )}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "BBmeeting" ? (
                      data?.teacherId ? (
                        <td>{data?.teacherId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "BBmeeting" ? (
                      data?.email ? (
                        <td>{data?.email}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "BBmeeting" ? (
                      data?.accessCode ? (
                        <td>{data?.accessCode}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "BBmeeting" ? (
                      data?.mettingId ? (
                        <td>{data?.mettingId}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "BBmeeting" ? (
                      data?.altAccessCode ? (
                        <td>{data?.altAccessCode}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "package" || pagename === "packageExtend" ? (
                      data?.status ? (
                        <td>{data?.status === 1 ? "Yes" : "No"}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "youtubelive" ? (
                      data?.subjects ? (
                        <td>{data?.subjects?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "youtubeRecorded" ? (
                      data?.subjectId ? (
                        <td>{data?.subjectId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "youtubelive" ||
                    pagename === "youtubeRecorded" ? (
                      data?.topicId ? (
                        <td>{data?.topicId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "youtubeRecorded" ? (
                      data?.teacherId ? (
                        <td>{data?.teacherId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "youtubelive" ? (
                      data?.banner ? (
                        <td>
                          <img
                            htmlFor="photo-upload"
                            src={data?.banner}
                            style={{
                              width: "40px",
                              height: "40px",
                            }}
                            alt={""}
                          />
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "youtubelive" ||
                    pagename === "youtubeRecorded" ? (
                      data?.title ? (
                        <td>{data?.title}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* {pagename === "youtubeRecorded" ? (
                      data?.title ? (
                        <td>{data?.lectureTitle}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null} */}
                    {pagename === "youtubelive" ? (
                      data?.teachers ? (
                        <td>{data?.teachers?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "youtubelive" ? (
                      data?.startTime ? (
                        <td>
                          {moment.utc(data?.startTime).format("DD/MM/YYYY LTS")}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "assignTeacher" ? (
                      data?.teacherId ? (
                        <td>{data?.teacherId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "assignTeacher" ? (
                      data?.subjectdata ? (
                        <td>{data?.subjectdata[0]?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "examSyllabus" ? (
                      data?.subjectName ? (
                        <td>{data?.subjectName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "examSyllabus" ? (
                      data?.subjectVideo ? (
                        <td>{data?.subjectVideo}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "examSyllabus" ? (
                      data?.priorityOrder || data?.priorityOrder === 0 ? (
                        <td>{data?.priorityOrder}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "assignTeacher" ? (
                      data?.subjectdata[0] ? (
                        <td>{getSessions(data?.subjectdata[0]?.topicData)}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "assignTeacher" ? (
                      data?.topicData ? (
                        data?.topicIdData[0]?.subtopicsData ? (
                          <td>
                            {getBatchNames(data?.topicIdData[0]?.subtopicsData)}
                          </td>
                        ) : (
                          <td>-</td>
                        )
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "adBanner" ? (
                      data?.bannerTypeId ? (
                        <td>{data?.bannerTypeId?.type}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "adBanner" || pagename === "jobType" ? (
                      data?.file ? (
                        <img
                          className="p-1"
                          htmlFor="photo-upload"
                          src={data?.file}
                          style={{
                            width: "50px",
                            height: "50px",
                          }}
                          alt={""}
                        />
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "examSet" ? (
                      data?.order != null ? (
                        <td>{data?.order}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "examSet" || pagename === "question" ? (
                      data?.isActive != null ? (
                        <td style={{ width: "5%" }} className="removelabel">
                          <ToggleSwitchBtn
                            id={data._id}
                            key={data._id}
                            isActive={data?.isActive ?? false}
                            getToggleval={(e) => onstatusChanged(e, data._id)}
                          />
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "examSet" ? (
                      data?.duration != null ? (
                        <td>{getSeconds(data?.duration)}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "whatsappShoot" ? (
                      <>
                        <td>{data?.firstName ? data?.firstName : "-"}</td>
                        <td>{data?.lastName ? data?.lastName : "-"}</td>
                        <td>{data?.examType ? data?.examType : "-"}</td>
                        <td>{data?.baseCourse ? data?.baseCourse : "-"}</td>
                        <td>
                          {data?.createdAt
                            ? moment(changeIntoIst(data?.createdAt)).format(
                                "DD-MM-YYYY HH:MM",
                              )
                            : "-"}
                        </td>
                        <td>{data?.sourceName ? data?.sourceName : "-"}</td>
                        <td>{data?.state ? data?.state : "-"}</td>
                      </>
                    ) : null}
                    {pagename === "notificationList" ? (
                      data?.courseId ? (
                        getSessions(data?.courseId)
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "notificationList" ? (
                      data?.sessionId ? (
                        getSessions(data?.sessionId)
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "notificationList" ? (
                      data?.notificationType ? (
                        <td>
                          {data?.notificationType === 1
                            ? "Class Schedule"
                            : data?.notificationType === 2
                              ? "Test Alert"
                              : data?.notificationType === 3
                                ? "Others"
                                : "Free User"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "notificationList" ? (
                      data?.title ? (
                        <td>{data?.title}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "notificationList" ? (
                      data?.notificationDate ? (
                        <td>
                          {moment
                            .utc(data?.notificationDate)
                            .format("DD/MM/YYYY LTS")}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "editPattern" ||
                    pagename === "stockManagement" ? (
                      data ? (
                        <td>{data?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "editSyllabusList" ? (
                      data ? (
                        <>
                          <td>{data?.subjectName}</td>
                          <td>
                            {data?.topicData?.map((tn, index) => {
                              return (
                                <tr
                                  key={index}
                                  style={{
                                    backgroundColor: "transparent",
                                    borderBottomWidth:
                                      tn?.topicData?.length !== index + 1
                                        ? 1
                                        : 0,
                                    display: "flex",
                                    paddingTop: 5,
                                    paddingBottom: 5,
                                  }}
                                >
                                  {tn?.topicName}
                                </tr>
                              );
                            })}
                          </td>
                          <td>
                            {data?.topicData?.map((tn) => {
                              return tn?.subTopicData?.map((std, index) => {
                                return (
                                  <tr
                                    key={index}
                                    style={{
                                      backgroundColor: "transparent",
                                      borderBottomWidth:
                                        std?.subTopicData?.length !== index + 1
                                          ? 1
                                          : 0,
                                      display: "flex",
                                      paddingTop: 5,
                                      paddingBottom: 5,
                                    }}
                                  >
                                    {std?.subTopicName}
                                  </tr>
                                );
                              });
                            })}
                          </td>
                          <td>
                            {data?.topicData?.map((tn) => {
                              return tn?.subTopicData?.map((ti) => {
                                return ti?.titleData?.map((tleData, index) => {
                                  return (
                                    <tr
                                      key={index}
                                      style={{
                                        backgroundColor: "transparent",
                                        borderBottomWidth:
                                          ti?.tleData?.length !== index + 1
                                            ? 1
                                            : 0,
                                        display: "flex",
                                        paddingTop: 5,
                                        paddingBottom: 5,
                                      }}
                                    >
                                      {tleData?.lectureTitle}
                                    </tr>
                                  );
                                });
                              });
                            })}
                          </td>
                          <td>
                            {data?.topicData?.map((tn) => {
                              return tn?.subTopicData?.map((ti) => {
                                return ti?.titleData?.map((tleData) => {
                                  return tleData?.teacherInfo.map(
                                    (tei, index) => {
                                      return (
                                        <tr
                                          key={index}
                                          style={{
                                            backgroundColor: "transparent",
                                            borderBottomWidth:
                                              tei?.teacherInfo?.length !==
                                              index + 1
                                                ? 1
                                                : 0,
                                            display: "flex",
                                            paddingTop: 5,
                                            paddingBottom: 5,
                                          }}
                                        >
                                          {tei?.preferredTeacher}
                                        </tr>
                                      );
                                    },
                                  );
                                });
                              });
                            })}
                          </td>
                          <td>
                            {data?.topicData?.map((tn) => {
                              return tn?.subTopicData?.map((ti) => {
                                return ti?.titleData?.map((tleData, index) => {
                                  return (
                                    <tr
                                      key={index}
                                      style={{
                                        backgroundColor: "transparent",
                                        borderBottomWidth:
                                          ti?.tleData?.length !== index + 1
                                            ? 1
                                            : 0,
                                        display: "flex",
                                        paddingTop: 5,
                                        paddingBottom: 5,
                                      }}
                                    >
                                      {tleData?.lectureDuration}
                                    </tr>
                                  );
                                });
                              });
                            })}
                          </td>
                          <td>
                            {data?.topicData?.map((tn) => {
                              return tn?.subTopicData?.map((ti) => {
                                return ti?.titleData?.map((tleData, index) => {
                                  return (
                                    <tr
                                      key={index}
                                      style={{
                                        backgroundColor: "transparent",
                                        borderBottomWidth:
                                          ti?.tleData?.length !== index + 1
                                            ? 1
                                            : 0,
                                        display: "flex",
                                        paddingTop: 5,
                                        paddingBottom: 5,
                                      }}
                                    >
                                      {tleData?.videoType}
                                    </tr>
                                  );
                                });
                              });
                            })}
                          </td>

                          <td>
                            {data?.topicData?.map((tn) => {
                              return tn?.subTopicData?.map((ti) => {
                                return ti?.titleData?.map((tleData) => {
                                  return (
                                    <tr
                                      key={index}
                                      style={{ backgroundColor: "transparent" }}
                                    >
                                      <span
                                        type="submit"
                                        className="text-primary fw-bold me-2 cursor"
                                        onClick={() =>
                                          handleEdit(tleData?.syllabusId)
                                        }
                                      >
                                        Edit
                                      </span>
                                      <span
                                        type="submit"
                                        className="text-danger fw-bold cursor"
                                        onClick={() =>
                                          handleDelete(tleData?.syllabusId)
                                        }
                                      >
                                        Delete
                                      </span>
                                    </tr>
                                  );
                                });
                              });
                            })}
                          </td>
                        </>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/******************** Whatsapp Message Analysis ************************/}
                    {pagename === "WhatappMessageAnalysis" ? (
                      data?.date ? (
                        <td className="">
                          {data?.date
                            ? moment.utc(data?.date).format("DD-MM-YYYY")
                            : "-"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "WhatappMessageAnalysis" ? (
                      data?.date ? (
                        <td className=" text-center cursor ">
                          <Chip
                            label={data?.notGenerated}
                            onClick={() =>
                              handleEdit(data?.date, "notGenerated")
                            }
                          />
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* {pagename === "WhatappMessageAnalysis" ? (
                      data?.type ? (
                        <td className="">
                          {data?.type}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null} */}
                    {pagename === "WhatappMessageAnalysis" ? (
                      data?.totalRegistrations ? (
                        <td className="">{data?.totalRegistrations}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "WhatappMessageAnalysis" ? (
                      <td className="">{data?.read || "-"}</td>
                    ) : null}
                    {pagename === "WhatappMessageAnalysis" ? (
                      <td className="">{data?.delivered || "-"}</td>
                    ) : null}
                    {pagename === "WhatappMessageAnalysis" ? (
                      data?.totalUsers ? (
                        <td className="">{data?.totalUsers}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "WhatappMessageAnalysis" ? (
                      data?.send ? (
                        <td className="">{data?.send}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "WhatappMessageAnalysis" ? (
                      data?.failed ? (
                        <td className=" text-center cursor">
                          <Chip
                            // sx={{ color: "red" }}
                            color="error"
                            label={data?.failed}
                            onClick={() => handleEdit(data?.date, "failed")}
                          />
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "WhatappMessageAnalysis" ? (
                      data?.sendRatio ? (
                        <td className="">{data?.sendRatio}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "WhatappMessageAnalysis" ? (
                      data?.failureRatio ? (
                        <td className="">{data?.failureRatio}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* *********************************************** */}
                    {pagename === "viewSyllabusList" &&
                      (data ? (
                        <>
                          <td>{data?.subjectName}</td>
                          <td>
                            {data?.topicData?.map((tn, index) => {
                              return (
                                <tr
                                  key={index}
                                  style={{
                                    backgroundColor: "transparent",
                                    borderBottomWidth:
                                      tn?.topicData?.length !== index + 1
                                        ? 1
                                        : 0,
                                    display: "flex",
                                    paddingTop: 5,
                                    paddingBottom: 5,
                                  }}
                                >
                                  {tn?.topicName}
                                </tr>
                              );
                            })}
                          </td>
                          <td>
                            {data?.topicData?.map((tn) => {
                              return tn?.subTopicData?.map((std, index) => {
                                return (
                                  <tr
                                    key={index}
                                    style={{
                                      backgroundColor: "transparent",
                                      borderBottomWidth:
                                        std?.subTopicData?.length !== index + 1
                                          ? 1
                                          : 0,
                                      display: "flex",
                                      paddingTop: 5,
                                      paddingBottom: 5,
                                    }}
                                  >
                                    {std?.subTopicName}
                                  </tr>
                                );
                              });
                            })}
                          </td>
                          <td>
                            {data?.topicData?.map((tn) => {
                              return tn?.subTopicData?.map((ti) => {
                                return ti?.titleData?.map((tleData, index) => {
                                  return (
                                    <tr
                                      key={index}
                                      style={{
                                        backgroundColor: "transparent",
                                        borderBottomWidth:
                                          ti?.tleData?.length !== index + 1
                                            ? 1
                                            : 0,
                                        display: "flex",
                                        paddingTop: 5,
                                        paddingBottom: 5,
                                      }}
                                    >
                                      {tleData?.lectureTitle}
                                    </tr>
                                  );
                                });
                              });
                            })}
                          </td>
                          <td>
                            {data?.topicData?.map((tn) => {
                              return tn?.subTopicData?.map((ti) => {
                                return ti?.titleData?.map((tleData) => {
                                  return tleData?.teacherInfo.map(
                                    (tei, index) => {
                                      return (
                                        <tr
                                          key={index}
                                          style={{
                                            backgroundColor: "transparent",
                                            borderBottomWidth:
                                              tei?.teacherInfo?.length !==
                                              index + 1
                                                ? 1
                                                : 0,
                                            display: "flex",
                                            paddingTop: 5,
                                            paddingBottom: 5,
                                          }}
                                        >
                                          {tei?.preferredTeacher}
                                        </tr>
                                      );
                                    },
                                  );
                                });
                              });
                            })}
                          </td>
                          <td>
                            {data?.topicData?.map((tn) => {
                              return tn?.subTopicData?.map((ti) => {
                                return ti?.titleData?.map((tleData, index) => {
                                  return (
                                    <tr
                                      key={index}
                                      style={{
                                        backgroundColor: "transparent",
                                        borderBottomWidth:
                                          ti?.tleData?.length !== index + 1
                                            ? 1
                                            : 0,
                                        display: "flex",
                                        paddingTop: 5,
                                        paddingBottom: 5,
                                      }}
                                    >
                                      {tleData?.lectureDuration}
                                    </tr>
                                  );
                                });
                              });
                            })}
                          </td>
                          <td>
                            {data?.topicData?.map((tn) => {
                              return tn?.subTopicData?.map((ti) => {
                                return ti?.titleData?.map((tleData, index) => {
                                  return (
                                    <tr
                                      key={index}
                                      style={{
                                        backgroundColor: "transparent",
                                        borderBottomWidth:
                                          ti?.tleData?.length !== index + 1
                                            ? 1
                                            : 0,
                                        display: "flex",
                                        paddingTop: 5,
                                        paddingBottom: 5,
                                      }}
                                    >
                                      {tleData?.videoType}
                                    </tr>
                                  );
                                });
                              });
                            })}
                          </td>
                        </>
                      ) : (
                        <td>-</td>
                      ))}
                    {pagename === "coupon" ? (
                      data?._id ? (
                        <>
                          <td>
                            {data?.examTypeId ? data?.examTypeId?.name : "-"}
                          </td>
                          <td>
                            {data?.baseCourseId
                              ? data?.baseCourseId?.name
                              : "-"}
                          </td>
                          {data?.sectionType?.map((item, index) => {
                            return (
                              <tr
                                key={index}
                                style={{ backgroundColor: "transparent" }}
                              >
                                <td>{item === 1 ? "FALSE" : "TRUE"}</td>
                              </tr>
                            );
                          })}
                          <td>{data?.discPer ? `${data?.discPer}%` : "-"}</td>
                          <td>
                            {data?.validHours ? `${data?.validHours} Hr` : "-"}
                          </td>
                          <td>
                            <Link to={data?.link} target="_blank">
                              Pdf Link
                            </Link>
                          </td>
                          <td>{data?.templateId ? data?.templateId : "-"}</td>
                          {data?.sectionType?.map((item, index) => {
                            return (
                              <tr
                                key={index}
                                style={{ backgroundColor: "transparent" }}
                              >
                                <td>
                                  {item === 2
                                    ? "STUDY MATERIAL"
                                    : item === 8
                                      ? "PRACTICE COURSE"
                                      : item === 7
                                        ? "PYQ COURSE"
                                        : item === 5
                                          ? "LECTURE SERIES"
                                          : item === 3
                                            ? "TEST SERIES"
                                            : item === 6
                                              ? "CRASH COURSE"
                                              : item === 1
                                                ? "ONLINE COURSE"
                                                : "-"}
                                </td>
                              </tr>
                            );
                          })}
                        </>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "liveRecVideoLectList" ? (
                      data?.subjectId ? (
                        <td>{data?.subjectId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "liveRecVideoLectList" ? (
                      data?.sessionId ? (
                        <td>{data?.sessionId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "liveRecVideoLectList" ? (
                      data?.topicId ? (
                        <td>{data?.topicId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "liveRecVideoLectList" ? (
                      data?.subTopicId ? (
                        <td>{data?.subTopicId[0]?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "liveRecVideoLectList" ||
                    pagename === "importRecVideoLectList" ||
                    pagename === "EditimportRecVideoLectList" ? (
                      data?.lectureTitle ? (
                        <td className="text-break">{data?.lectureTitle}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "liveRecVideoLectList" ? (
                      data?.order || data?.order === 0 ? (
                        <td>{data?.order}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "liveRecVideoLectList" ? (
                      data?.examId?.en ? (
                        <td>{data?.examId?.en?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "liveRecVideoLectList" ? (
                      data?.lectureTime ? (
                        <td>{moment.utc(data.lectureTime).format("LL")}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "classroomBatch" ? (
                      data?.date ? (
                        <td>{moment.utc(data.date).format("LL")}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "EditDeletePyqPdf" ? (
                      data?.batchName ? (
                        <td>{data?.batchName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "EditDeletePyqPdf" ? (
                      data?.order || data?.order === 0 ? (
                        <td>{data?.order}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "classroomStudents" ||
                    pagename === "examResults" ? (
                      data?.userId?.firstName ? (
                        <td>{data?.userId?.firstName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "classroomStudents" ||
                    pagename === "examResults" ? (
                      data?.userId?.lastName ? (
                        <td>{data?.userId?.lastName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "classroomStudents" ? (
                      data?.createdAt ? (
                        <td>
                          {moment.utc(data.createdAt).format("DD-MM-YYYY")}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* {
                      pagename === "classroomStudents" ||
                      pagename === "examResults" ? (
                        data?.userId?.mobileNo ? (
                          <td>{data?.userId?.mobileNo}</td>
                        ) : (
                          <td>-</td>
                        )
                      ) : null
                    } */}
                    {pagename === "examResults" ? (
                      data?.startDate ? (
                        <td>
                          {moment.utc(data.startDate).format("DD-MM-YYYY")}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* {
                    pagename === "classroomStudents"  ? (
                      data?.userId?.email ? (
                        <td>{data?.userId?.email}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null} */}
                    {pagename === "classroomStudents" ? (
                      data?.userId?.stateId?.name ? (
                        <td>{data?.userId?.stateId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "classroomStudents" ? (
                      data?.branchName ? (
                        <td>{data?.branchName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "classroomStudents" ? (
                      data?.isClassRoomPayment === true ||
                      data?.isClassRoomPayment === false ? (
                        <td>{data?.isClassRoomPayment ? "Yes" : "No"}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "classroomStudents" ? (
                      data?.couponName ? (
                        <td>{data?.couponName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}

                    {pagename === "classroomStudents" ? (
                      data?.amount && data?.isClassRoomPayment ? (
                        <td>{data?.amount}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "userFeedBack" ? (
                      data?.baseCourseName ? (
                        <td>{data?.baseCourseName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "userFeedBack" ? (
                      data?.examName ? (
                        <td>{data?.examName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "userFeedBack" ? (
                      data?.examName ? (
                        <td>{data?.subExamName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "userFeedBack" ? (
                      data?.courseName ? (
                        <td>{data?.courseName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "courseFeedBack" ||
                    pagename === "TeacherHoursList" ||
                    pagename === "editTeacherHoursList" ? (
                      data?.lectureName ? (
                        <td>{data?.lectureName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "courseFeedBack" ? (
                      data?.subjectName ? (
                        <td>{data?.subjectName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "courseFeedBack" ? (
                      data?.topicName ? (
                        <td>{data?.topicName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "courseFeedBack" ? (
                      data?.subtopicName ? (
                        <td>{data?.subtopicName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "userFeedBack" ||
                    pagename === "courseFeedBack" ? (
                      data?.reviewCount ? (
                        <td>{data?.reviewCount}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "userFeedBack" ||
                    pagename === "courseFeedBack" ? (
                      data?.overallRating ? (
                        <td>
                          {Math.round(
                            (parseFloat(data?.overallRating) + Number.EPSILON) *
                              10,
                          ) / 10}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "importRecVideoLectList" ||
                    pagename === "EditimportRecVideoLectList" ? (
                      data?.duration ? (
                        <td className="text-break">{data?.duration}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "importRecVideoLectList" ||
                    pagename === "EditimportRecVideoLectList" ? (
                      data?.description ? (
                        <td className="text-break">{data?.description}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "importRecVideoLectList" ||
                    pagename === "EditimportRecVideoLectList" ? (
                      data?.s3LinkHigh ? (
                        <td className="text-break">{data?.s3LinkHigh}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "importRecVideoLectList" ||
                    pagename === "EditimportRecVideoLectList" ? (
                      data?.s3LinkLow ? (
                        <td className="text-break">{data?.s3LinkLow}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "EditimportRecVideoLectList" ? (
                      data?.examId?.en?.name ? (
                        <td>{data?.examId?.en?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "importRecVideoLectList" ? (
                      data?.examDppName ? (
                        <td className="text-break">{data?.examDppName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "EditimportRecVideoLectList" ? (
                      data?.handout1Url ? (
                        <td>{data?.handout1Url}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "importRecVideoLectList" ? (
                      data?.handout2Url ? (
                        <td className="text-break">
                          {data?.handout1Url},{data?.handout2Url}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "TeacherHoursList" ||
                    pagename === "editTeacherHoursList" ? (
                      data?.lectureDate ? (
                        <td>{moment.utc(data?.lectureDate).format("LL")}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "TeacherHoursList" ||
                    pagename === "editTeacherHoursList" ? (
                      data?.lectureDuration ? (
                        <td>{Math.round(data?.lectureDuration * 100) / 100}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "TeacherHoursList" ||
                    pagename === "editTeacherHoursList" ? (
                      data?.lectureType ? (
                        <td>
                          {data?.lectureType === 1
                            ? "Live Lecture"
                            : data?.lectureType === 2
                              ? "Recorded Lecture"
                              : data?.lectureType === 3
                                ? "Test Series"
                                : data?.lectureType === 4
                                  ? "Book"
                                  : "Youtube Live"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "finTransEductech" &&
                      (data ? (
                        <>
                          <td>{data?.orderNo}</td>
                          <td>
                            {moment.utc(data.date).format("DD-MM-YYYY ; LT")}
                          </td>
                          <td>
                            {data?.userDetails?.firstName}{" "}
                            {data?.userDetails?.lastName}
                          </td>
                          {/* <td>{data?.userDetails?.mobileNo}</td> */}
                          <td>{getBatchName(data?.courses)}</td>
                          <td>{getSubscriptionMonths(data?.courses)}</td>
                          <td>{getActualPrice(data?.courses)}</td>
                          <td>{getGSTPrice(data?.courses)}</td>
                          <td>{getEdutechTotalPrice(data?.courses)}</td>
                          <td>{getCoupon(data?.courses)}</td>
                          <td>{getDiscountedValue(data?.courses)}</td>
                          {/* <td>
                            {data?.status === 0
                              ? "Created"
                              : data?.status === 1
                              ? "In Progress"
                              : data?.status === 2
                              ? "Successful"
                              : data?.status === 9
                              ? "Cancelled"
                              : "-"}
                          </td> */}
                        </>
                      ) : (
                        <td>-</td>
                      ))}
                    {pagename === "subDepartment" ? (
                      data ? (
                        <>
                          <td>
                            {data?.departments?._id
                              ? data?.departments?.name
                              : "-"}
                          </td>
                          <td>{data?.name ? data?.name : "-"}</td>
                        </>
                      ) : null
                    ) : null}
                    {pagename === "finRefundTransEductech" &&
                      (data ? (
                        <>
                          <td>{data?.orderNo}</td>

                          <td>
                            {data?.userDetails?.firstName}{" "}
                            {data?.userDetails?.lastName}
                          </td>
                          {/* <td>{data?.userDetails?.mobileNo}</td> */}
                          <td>{data?.coursedata[0]?.name}</td>
                          <td>{data?.courses[0]?.subscriptionPlanMonths}</td>
                          <td>
                            {data?.courses
                              ? getTotalPriceSum(data?.courses)
                              : "-"}
                          </td>
                          <td>{data?.RefundDetails?.refundAmount}</td>
                          <td>
                            {moment
                              .utc(data.createdAt)
                              .format("DD-MM-YYYY ; LT")}
                          </td>
                          <td>
                            {data?.RefundDetails?.status === 2
                              ? "Refunded"
                              : ""}
                          </td>
                        </>
                      ) : (
                        <td>-</td>
                      ))}
                    {pagename === "paymentPublication" ? (
                      <>
                        <td>{data?.orderNo ? data?.orderNo : "-"}</td>
                        <td>
                          {data?.createdAt
                            ? moment
                                .utc(data?.date)
                                .format("DD-MM-YYYY hh:mm:ss A")
                            : "-"}
                        </td>
                        <td>
                          {data?.userDetails
                            ? `${data?.userDetails?.firstName} ${data?.userDetails?.lastName}`
                            : "-"}
                        </td>
                        <td>
                          {data?.cityDetails
                            ? `${data?.cityDetails?.name}`
                            : "-"}
                        </td>
                        <td>
                          {data?.stateDetails || data?.stateId
                            ? `${
                                data?.stateDetails?.name
                                  ? data?.stateDetails?.name
                                  : data?.stateId?.name
                              }`
                            : "-"}
                        </td>
                        <td>
                          {data?.coursedata
                            ? `${data?.coursedata[0]?.name}`
                            : "-"}
                        </td>
                        <td>
                          {data?.courses
                            ? `${data?.courses[0]?.subscriptionPlanMonths}`
                            : "-"}
                        </td>
                        <td>
                          {data?.courses
                            ? getTotalPriceSum(data?.courses)
                            : "-"}
                        </td>
                        <td>
                          {data?.courses
                            ? `${data?.courses[0]?.couponName}`
                            : "-"}
                        </td>
                        <td>
                          {data?.courses
                            ? getDiscountPrice(data?.courses)
                            : "-"}
                        </td>
                        <td>
                          {data
                            ? `${data?.paymentGatewayResponse[0]?.status}`
                            : "-"}
                        </td>
                      </>
                    ) : null}
                    {pagename === "editNotes" ? (
                      <>
                        <td className=" font10">
                          {data?.examTypeId?.name ||
                          data?.baseCourseId?.name ? (
                            <>
                              {data?.examTypeId?.name || ""}
                              {data?.examTypeId?.name &&
                                data?.baseCourseId?.name && <br />}
                              {data?.baseCourseId?.name || ""}
                            </>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>
                          {data?.courseIds?.length
                            ? data.courseIds.map((item, index) => (
                                <div
                                  key={item?._id || index}
                                  className="font10"
                                >
                                  -- {item?.name}
                                </div>
                              ))
                            : "-"}
                        </td>
                        <td>{data?.topicId?.name || ""}</td>
                        <td>{data?.subjectId?.name || ""}</td>
                      </>
                    ) : null}
                    {pagename === "totalRevenue" &&
                      (data ? (
                        <>
                          <td>{data?.orderNo}</td>
                          <td>
                            {moment.utc(data.date).format("DD-MM-YYYY LT")}
                          </td>
                          <td>{getBatchName(data?.courses)}</td>
                          <td>{getSubscriptionMonths(data?.courses)}</td>
                          <td>{getPublicationTotalPrice(data?.courses)}</td>
                          <td>{getActualPrice(data?.courses)}</td>
                          <td>{getGSTPrice(data?.courses)}</td>
                          <td>{getEdutechTotalPrice(data?.courses)}</td>
                          <td>{getTotalPriceForTotalRevenue(data?.courses)}</td>
                          <td>{getCoupon(data?.courses)}</td>
                          <td>{getDiscountedValue(data?.courses)}</td>
                        </>
                      ) : (
                        <td>-</td>
                      ))}
                    {pagename === "revenueData" &&
                      (data ? (
                        <>
                          <td>{data?.orderNo}</td>
                          <td>
                            {moment.utc(data.orderDate).format("DD-MM-YYYY LT")}
                          </td>
                          <td>{data?.courseName}</td>
                          <td>{data?.subscriptions}</td>
                          <td>{data?.actualAmount}</td>
                          <td>{data?.gst_Amount}</td>
                          <td>{data?.totalAmount}</td>
                          <td>{data?.couponName}</td>
                          <td>{data?.totalDiscount}</td>
                        </>
                      ) : (
                        <td>-</td>
                      ))}
                    {pagename === "quizConfigList" &&
                      (data ? (
                        <>
                          <td>{data?.examType?.name}</td>
                          <td>{data?.baseCourse?.name}</td>
                          <td>{data?.quizMode}</td>
                        </>
                      ) : (
                        <td>-</td>
                      ))}
                    {pagename === "referenceTarget" &&
                      (data ? (
                        <>
                          <td>{data?.studentName}</td>
                          <td>{data?.mobileNo}</td>
                          <td>{data?.basecourseName}</td>
                          <td>{data?.examTypeName}</td>
                        </>
                      ) : (
                        <td>-</td>
                      ))}
                    {pagename === "influencerRank" &&
                      (data ? (
                        <>
                          <td>{data?.rank ? data?.rank : "-"}</td>
                          <td>
                            {data?.influencerName ? data?.influencerName : "-"}
                          </td>
                          <td>{data?.targetType ? data?.targetType : "-"}</td>
                          <td>{data?.revenue ? data?.revenue : "-"}</td>
                        </>
                      ) : (
                        <td>-</td>
                      ))}
                    {pagename === "transactionEdutech" &&
                      (data ? (
                        <>
                          <td>{data?.orderNo}</td>
                          <td>
                            {moment.utc(data.date).format("DD-MM-YYYY ; LT")}
                          </td>
                          <td>{getBatchName(data?.courses)}</td>
                          <td>{getSubscriptionMonths(data?.courses)}</td>
                          <td>{getActualPrice(data?.courses)}</td>
                          <td>{getGSTPrice(data?.courses)}</td>
                          <td>{getEdutechTotalPrice(data?.courses)}</td>
                          <td>{getCoupon(data?.courses)}</td>
                          <td>{getDiscountedValue(data?.courses)}</td>
                          <td colSpan={2}>
                            {data?.status !== 2 ? (
                              <span
                                type="button"
                                className="text-primary fw-bold me-2 cursor"
                                onClick={() => handleViewMore(data)}
                              >
                                View
                              </span>
                            ) : (
                              <span />
                            )}
                          </td>
                          {role === "CXO" && (
                            <td
                              type="submit"
                              className="text-success fw-bold cursor"
                              onClick={() => {
                                handleDelete(data);
                              }}
                            >
                              <WhatsAppIcon fontSize="small" />
                            </td>
                          )}
                        </>
                      ) : (
                        <td colSpan={12}>-</td> // ✅ now matches the 12 columns after S.N
                      ))}

                    {pagename === "transactionPublication" ||
                    pagename === "studyMaterialOrders" ||
                    pagename === "AllDetailsSMOrders" ||
                    pagename === "transactionEdutechVP" ||
                    pagename === "transactionEdutechStudyMaterialVP" ||
                    pagename === "transactionEdutechStudyMaterial" ||
                    pagename ===
                      "transactionEdutechStudyMaterialTechSupport" ? (
                      data?.orderNo ? (
                        <td>{data?.orderNo}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "transactionPublication" ||
                    pagename === "transactionEdutechVP" ||
                    pagename === "transactionEdutechStudyMaterialVP" ||
                    pagename === "transactionEdutechStudyMaterial" ||
                    pagename ===
                      "transactionEdutechStudyMaterialTechSupport" ? (
                      data?.date ? (
                        <td>
                          {moment
                            .utc(data?.date)
                            .format("DD-MM-YYYY hh:mm:ss A")}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "transactionEdutechVP" ||
                    pagename === "transactionEdutechStudyMaterialVP" ? (
                      data?.userDetails ? (
                        <td>
                          {data?.userDetails?.firstName}{" "}
                          {data?.userDetails?.lastName}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "transactionEdutechVP" ||
                    pagename === "transactionEdutechStudyMaterialVP" ? (
                      data?.userDetails ? (
                        <td>{data?.userDetails?.mobileNo}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "transactionEdutechVP" ||
                    pagename === "transactionEdutechStudyMaterialVP" ? (
                      data?.cityDetails ? (
                        <td>{data?.cityDetails?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "transactionEdutechVP" ||
                    pagename === "transactionEdutechStudyMaterialVP" ? (
                      data?.stateDetails || data?.stateId ? (
                        <td>
                          {data?.stateDetails?.name
                            ? data?.stateDetails?.name
                            : data?.stateId?.name}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "transactionPublication" ? (
                      data?.stateDetails ? (
                        <td>{data?.stateDetails[0]?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "transactionPublication" ||
                    pagename === "transactionEdutechVP" ||
                    pagename === "transactionEdutechStudyMaterialVP" ||
                    pagename === "transactionEdutechStudyMaterial" ||
                    pagename ===
                      "transactionEdutechStudyMaterialTechSupport" ? (
                      data?.coursedata ? (
                        <td>{data?.coursedata[0]?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "transactionEdutechStudyMaterial" ||
                    pagename ===
                      "transactionEdutechStudyMaterialTechSupport" ? (
                      data?.courses ? (
                        <td>{getSubscriptionMonths(data?.courses)}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "transactionEdutechStudyMaterial" ||
                    pagename === "transactionPublication" ||
                    pagename ===
                      "transactionEdutechStudyMaterialTechSupport" ? (
                      data?.courses ? (
                        <td>{getPublicationTotalPrice(data?.courses)}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "transactionPublication" ? (
                      data?.courses ? (
                        <td>{0}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "transactionEdutechStudyMaterial" ||
                    pagename ===
                      "transactionEdutechStudyMaterialTechSupport" ? (
                      data?.courses ? (
                        <td>{getActualPrice(data?.courses)}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "transactionPublication" ? (
                      data?.courses ? (
                        <td>{getPublicationTotalPrice(data?.courses)}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "transactionEdutechStudyMaterial" ||
                    pagename ===
                      "transactionEdutechStudyMaterialTechSupport" ? (
                      data?.courses ? (
                        <td>{getGSTPrice(data?.courses)}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "transactionEdutechStudyMaterial" ||
                    pagename ===
                      "transactionEdutechStudyMaterialTechSupport" ? (
                      data?.courses ? (
                        <td>{getEdutechTotalPrice(data?.courses)}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "transactionEdutechStudyMaterial" ||
                    pagename ===
                      "transactionEdutechStudyMaterialTechSupport" ? (
                      data?.courses ? (
                        <td>{getEdutechSumPrice(data?.courses)}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "transactionEdutechStudyMaterial" ||
                    pagename === "transactionPublication" ? (
                      data?.courses ? (
                        <td>{getCoupon(data?.courses)}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "transactionEdutechStudyMaterial" ||
                    pagename ===
                      "transactionEdutechStudyMaterialTechSupport" ? (
                      data?.courses ? (
                        <td>{getDiscountedValue(data?.courses)}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "transactionEdutechStudyMaterial" ||
                    pagename ===
                      "transactionEdutechStudyMaterialTechSupport" ? (
                      data ? (
                        <td colSpan={2}>
                          {data?.status !== 2 ? (
                            <span
                              type="button"
                              className="text-primary fw-bold me-2 cursor"
                              onClick={() => handleViewMore(data)}
                            >
                              View
                            </span>
                          ) : null}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "transactionEdutechStudyMaterial" &&
                      role === "CXO" &&
                      (data ? (
                        <td
                          className="text-success fw-bold cursor"
                          onClick={() => handleDelete(data)}
                        >
                          <WhatsAppIcon fontSize="small" />
                        </td>
                      ) : (
                        <td>-</td>
                      ))}
                    {pagename === "transactionPublication" ? (
                      data?.courses ? (
                        <td>{getPublicationDiscountPrice(data?.courses)}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "transactionPublication" ? (
                      data ? (
                        <span
                          type="submit"
                          className="fw-bold cursor pt-2"
                          style={{ color: "green" }}
                          onClick={() => handleRefund(data)}
                        >
                          Refund Amount
                        </span>
                      ) : null
                    ) : null}
                    {pagename === "transactionPublication" ? (
                      data ? (
                        <td colSpan={2}>
                          {data?.status !== 2 ? (
                            <span
                              type="button"
                              className="text-primary fw-bold me-2 cursor"
                              onClick={() => handleViewMore(data)}
                            >
                              View
                            </span>
                          ) : null}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "transactionPublication" && role === "CXO" ? (
                      data ? (
                        <td
                          className="text-success fw-bold cursor"
                          onClick={() => handleDelete(data)}
                        >
                          <WhatsAppIcon fontSize="small" />
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "paymentPublication" ? (
                      data?.status >= 0 ? (
                        <td>
                          {data?.status === 0
                            ? "Created"
                            : data?.status === 1
                              ? "In Progress"
                              : data?.status === 2
                                ? "Successful"
                                : data?.status === 9
                                  ? "Cancelled"
                                  : "-"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "datewiseCount" ||
                    pagename === "studentCount" ||
                    pagename === "stateStudentCount" ? (
                      data?.name ? (
                        <td>{data?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "referenceGenerated" ? (
                      <>
                        <td>{data?.exam ? data?.exam : "-"}</td>
                        <td>{data?.examStream ? data?.examStream : "-"}</td>
                        <td>{data?.leads ? data?.leads : "-"}</td>
                      </>
                    ) : null}
                    {pagename === "seoBlogs" ? (
                      <>
                        <td>
                          {data?.examTypeId ? data?.examTypeId?.name : "-"}
                        </td>
                        <td>
                          {data?.subExamTypeId
                            ? data?.subExamTypeId?.name
                            : "-"}
                        </td>
                        <td>
                          {data?.baseCourseId ? data?.baseCourseId?.name : "-"}
                        </td>
                        <td>{data?.title ? data?.title : "-"}</td>
                        <td>{data?.author?._id ? data?.author?.name : "-"}</td>
                        <td>
                          {data?.title ? (
                            <Tooltip title="View">
                              <IconButton
                                className=" cursor"
                                onClick={() => handleViewMore(data)}
                              >
                                <VisibilityIcon />
                              </IconButton>
                            </Tooltip>
                          ) : (
                            "-"
                          )}
                        </td>
                      </>
                    ) : null}
                    {pagename === "batchwiseCount" ||
                    pagename === "cxoBatchWiseCount" ||
                    pagename === "academicBatchWiseCount" ? (
                      data?.courseName ? (
                        <td>{data?.courseName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "batchwiseCount" ||
                    pagename === "cxoBatchWiseCount" ||
                    pagename === "academicBatchWiseCount" ? (
                      data?.addmissionCount ? (
                        <td>{data?.addmissionCount}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "batchwiseCount" ? (
                      data?.withoutGstTotalAmount ? (
                        <td>
                          {" "}
                          {data?.withoutGstTotalAmount
                            ? (data?.withoutGstTotalAmount).toFixed(2)
                            : data?.withoutGstTotalAmount === 0
                              ? 0
                              : "-"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "batchwiseCount" ? (
                      data?.totalGstAmount ? (
                        <td>
                          {" "}
                          {data?.totalGstAmount
                            ? (data?.totalGstAmount).toFixed(2)
                            : data?.totalGstAmount === 0
                              ? 0
                              : "-"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "batchwiseCount" ? (
                      data?.amount ? (
                        <td>
                          {data?.amount
                            ? (data?.amount).toFixed(2)
                            : data?.amount === 0
                              ? 0
                              : "-"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "cxoBatchWiseCount" ? (
                      data?.withoutGstTotalAmount ? (
                        <td>{(data?.withoutGstTotalAmount).toFixed(2)}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "cxoBatchWiseCount" ? (
                      data?.totalGstAmount ? (
                        <td>{(data?.totalGstAmount).toFixed(2)}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "cxoBatchWiseCount" ? (
                      data?.amount ? (
                        <td>{(data?.amount).toFixed(2)}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "datewiseCount" ||
                    pagename === "studentCount" ||
                    pagename === "stateStudentCount" ? (
                      data ? (
                        <td>{data?.studentCount}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "referenceLeadCount" ? (
                      data?.studentleadCount ? (
                        <td>{data?.studentleadCount}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "referenceTeamLeadCount" ? (
                      data?.studentLeadsIds ? (
                        <td>{data?.studentLeadsIds}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "studentCount" ? (
                      data ? (
                        <td>{data?.countPercentage}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "stateStudentCount" ? (
                      data ? (
                        <td>{data?.countPercentage}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "datewiseCount" ? (
                      data?.withoutGstAmount ? (
                        <td>
                          {" "}
                          {data?.withoutGstAmount
                            ? (data?.withoutGstAmount).toFixed(2)
                            : data?.withoutGstAmount === 0
                              ? 0
                              : "-"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "datewiseCount" ? (
                      data?.totalGstAmount ? (
                        <td>
                          {" "}
                          {data?.totalGstAmount
                            ? (data?.totalGstAmount).toFixed(2)
                            : data?.totalGstAmount === 0
                              ? 0
                              : "-"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "datewiseCount" ? (
                      data?.shopifyAmount ? (
                        <td>
                          {" "}
                          {data?.shopifyAmount
                            ? (data?.shopifyAmount).toFixed(2)
                            : data?.shopifyAmount === 0
                              ? 0
                              : "-"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "datewiseCount" ? (
                      data?.amount ? (
                        <td>
                          {data?.amount
                            ? (data?.amount).toFixed(2)
                            : data?.amount === 0
                              ? 0
                              : "-"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "revenueDetails" ? (
                      data ? (
                        <td>{data?.examName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "revenueDetails" ? (
                      data ? (
                        <td>{data?.edutech}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "revenueDetails" ? (
                      data ? (
                        <td>{data?.publication}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "assetList" ? (
                      <>
                        <td>{data?.name ? data?.name : "-"}</td>
                      </>
                    ) : null}
                    {pagename === "sourceNameList" ? (
                      <>
                        <td>{data?.name ? data?.name : "-"}</td>
                      </>
                    ) : null}
                    {pagename === "editTdsList" ? (
                      <>
                        <td>{data?.name ? data?.name : "-"}</td>
                        <td>{data?.rate ? data?.rate : "-"}</td>
                      </>
                    ) : null}
                    {pagename === "deviceCompany" ? (
                      <>
                        <td>{data?.name ? data?.name : "-"}</td>
                      </>
                    ) : null}
                    {pagename === "deviceModel" ? (
                      <>
                        <td>{data?.name ? data?.name : "-"}</td>
                      </>
                    ) : null}
                    {/* Order Date */}
                    {pagename === "studyMaterialOrders" ||
                    pagename === "AllDetailsSMOrders" ? (
                      data?.date ? (
                        <td>{moment.utc(data.date).format("DD-MM-YYYY")}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* Buyer Name */}
                    {pagename === "studyMaterialOrders" ||
                    pagename === "AllDetailsSMOrders" ? (
                      data?.usersData ? (
                        <td>
                          {data?.usersData?.firstName}{" "}
                          {data?.usersData?.lastName}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* Address */}
                    {pagename === "AllDetailsSMOrders" ? (
                      data?.address ? (
                        <td>{`${data?.address?.line1}, ${data?.address?.line2}, ${data?.address?.landmark}, ${data?.address?.cityId?.name}, ${data?.address?.stateId?.name}- ${data?.address?.pincode}.`}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* City */}
                    {pagename === "AllDetailsSMOrders" ? (
                      data?.address?.cityId ? (
                        <td>{data?.address?.cityId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* state */}
                    {pagename === "studyMaterialOrders" ||
                    pagename === "AllDetailsSMOrders" ? (
                      data?.address?.stateId ? (
                        <td>{data?.address?.stateId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* pincode */}
                    {pagename === "AllDetailsSMOrders" ? (
                      data?.address?.pincode ? (
                        <td>{data?.address?.pincode}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* Mobile Number */}
                    {pagename === "studyMaterialOrders" ||
                    pagename === "AllDetailsSMOrders" ? (
                      data?.usersData?.mobileNo ? (
                        <td>{data?.usersData?.mobileNo}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* Price */}
                    {pagename === "studyMaterialOrders" ||
                    pagename === "AllDetailsSMOrders" ? (
                      data?.netPayableAmount ? (
                        <td>{data?.netPayableAmount}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* Mail */}
                    {pagename === "AllDetailsSMOrders" ? (
                      data?.usersData?.email ? (
                        <td>{data?.usersData?.email}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* book detail */}
                    {pagename === "AllDetailsSMOrders" ? (
                      data?.courses ? (
                        getSMBookList(data?.courses)
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* book type */}
                    {pagename === "AllDetailsSMOrders" ? (
                      data?.courses ? (
                        getSMBookType(data?.courses)
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* parent course */}
                    {pagename === "studyMaterialOrders" ||
                    pagename === "AllDetailsSMOrders" ||
                    pagename === "configQuestion" ? (
                      data?.baseCourse ? (
                        <td>{data?.baseCourse?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* exam type */}
                    {pagename === "AllDetailsSMOrders" ||
                    pagename === "configQuestion" ? (
                      data?.examType ? (
                        <td>{data?.examType?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* sub exam type */}
                    {pagename === "AllDetailsSMOrders" ||
                    pagename === "configQuestion" ? (
                      data?.subExamType ? (
                        <td>{data?.subExamType?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* tracking ID  */}
                    {pagename === "AllDetailsSMOrders" ? (
                      data?.trackingIdDetails ? (
                        getTrackingIdList(data?.trackingIdDetails)
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* delivery Charge */}
                    {pagename === "AllDetailsSMOrders" ? (
                      data?.deliveryFee >= 0 ? (
                        <td>{data?.deliveryFee}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* Dispatch Date */}
                    {pagename === "studyMaterialOrders" ||
                    pagename === "AllDetailsSMOrders" ? (
                      data?.dispatchedDate ? (
                        <td>
                          {moment.utc(data.dispatchedDate).format("DD-MM-YYYY")}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* order pendings */}
                    {pagename === "AllDetailsSMOrders" ? (
                      data?.remainingBookDetails ? (
                        getSubCategories(data?.remainingBookDetails)
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* next dispatched date */}
                    {pagename === "AllDetailsSMOrders" ? (
                      data?.nextDispatchedDate ? (
                        <td>
                          {moment
                            .utc(data.nextDispatchedDate)
                            .format("DD-MM-YYYY")}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "stockManagement" ? (
                      data?.quantity ? (
                        <td>{data?.quantity}</td>
                      ) : data?.quantity === 0 ? (
                        <td>{data?.quantity}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "stockManagement" ? (
                      data?.quantity ? (
                        <td>{data?.status === 1 ? "Available" : ""}</td>
                      ) : data?.status === 0 ? (
                        <td>{"Out Of Stock"}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "bookHistory" ? (
                      data?.createdAt ? (
                        <td>
                          {moment
                            .utc(data.createdAt)
                            .format("DD-MM-YYYY hh:mm:ss")}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "bookHistory" ? (
                      data?.lastQuantity ? (
                        <td>{data?.lastQuantity}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "bookHistory" ? (
                      data?.quantity ? (
                        <td>{data?.quantity}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "bookHistory" ? (
                      data?.currentQuantity ? (
                        <td>{data?.currentQuantity}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "bookHistory" ? (
                      data?.printerName ? (
                        <td>{data?.printerName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "bookHistory" ? (
                      data?.totalAmount ? (
                        <td>{data?.totalAmount}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "admissionHistory" ||
                    pagename === "academicHead" ||
                    pagename === "cxoBatchWiseCountDetail" ? (
                      data?.firstName ? (
                        <td>{data?.firstName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "admissionHistory" ||
                    pagename === "academicHead" ||
                    pagename === "cxoBatchWiseCountDetail" ? (
                      data?.lastName ? (
                        <td>{data?.lastName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "academicHead" ? (
                      data?.username ? (
                        <td>{data?.username}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* {pagename === "admissionHistory" ? (
                      data?.mobileNo ? (
                        <td>{data?.mobileNo}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null} */}
                    {pagename === "admissionHistory" ||
                    pagename === "cxoBatchWiseCountDetail" ? (
                      data?.state ? (
                        <td>{data?.state}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "admissionHistory" ||
                    pagename === "cxoBatchWiseCountDetail" ? (
                      data?.date ? (
                        <td>
                          {data?.date
                            ? moment.utc(data?.date).format("DD-MM-YYYY")
                            : moment.utc(data?.startDate).format("DD-MM-YYYY")}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "admissionHistory" ||
                    pagename === "cxoBatchWiseCountDetail" ? (
                      data?.endDate ? (
                        <td>
                          {data?.endDate
                            ? moment.utc(data?.endDate).format("DD-MM-YYYY")
                            : "-"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "cxoBatchWiseCountDetail" ? (
                      data?.total ? (
                        <td>{data?.total}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "registrationDetails" ||
                    pagename === "dataRegistrationDetails" ? (
                      data?.examData?.name ? (
                        <td>{data?.examData?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "registrationDetails" ||
                    pagename === "dataRegistrationDetails" ? (
                      data?.subExamTypeId?.name ? (
                        <td>{data?.subExamTypeId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "registrationDetails" ||
                    pagename === "dataRegistrationDetails" ? (
                      data?.coursesData?.name ? (
                        <td>
                          {data?.coursesData?.name}
                          {data?.coursesData?.sectionType === 5
                            ? " - " + data?.name
                            : ""}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "registrationDetails" ||
                    pagename === "dataRegistrationDetails" ? (
                      data?.coursesData?.sectionType ? (
                        <td>
                          {data?.coursesData?.sectionType === 1
                            ? "COURSE"
                            : data?.coursesData?.sectionType === 2
                              ? "STUDY MATERIAL"
                              : data?.coursesData?.sectionType === 3
                                ? "TEST SERIES"
                                : data?.coursesData?.sectionType === 4
                                  ? "E-BOOK"
                                  : data?.coursesData?.sectionType === 5
                                    ? "LECTURE SERIES"
                                    : data?.coursesData?.sectionType === 6
                                      ? "CRASH COURSE"
                                      : data?.coursesData?.sectionType === 7
                                        ? "PYQ COURSE"
                                        : data?.coursesData?.sectionType === 8
                                          ? "PRACTICE COURSE"
                                          : data?.coursesData?.sectionType === 9
                                            ? "CLASSROOM"
                                            : "-"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "registrationDetails" ||
                    pagename === "dataRegistrationDetails" ||
                    pagename === "configQuestion" ? (
                      data?.status >= 0 ? (
                        <td>{data?.status === 1 ? "Yes" : "No"}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "registrationDetails" ||
                    pagename === "dataRegistrationDetails" ? (
                      data?.endDate ? (
                        <td>
                          {moment.utc(data?.endDate).format("DD-MM-YYYY")}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "registrationDetails" ||
                    pagename === "dataRegistrationDetails" ? (
                      data?.selectedPackage ? (
                        <td> {data.selectedPackage.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "examResultsDetails" ? (
                      data?.examData[0]?.en?.name ? (
                        <td>{data?.examData[0]?.en?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "examResultsDetails" ? (
                      data?.examData[0]?.duration ? (
                        <td>{data?.examData[0]?.duration}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "examResultsDetails" ? (
                      data?.examData[0]?.status >= 0 ? (
                        <td>
                          {data?.examData[0]?.status === 0
                            ? "Not Submitted"
                            : data?.examData[0]?.status === 1
                              ? "Submitted"
                              : "-"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "examResultsDetails" ? (
                      data?.examData[0]?.totalAddedQuestion ? (
                        <td>{data?.examData[0]?.totalAddedQuestion}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "examResultsDetails" ? (
                      data?.examStats?.correct ? (
                        <td>{data?.examStats?.correct}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "examResultsDetails" ? (
                      data?.examStats?.incorrect ? (
                        <td>{data?.examStats?.incorrect}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "examResultsDetails" ? (
                      data?.examStats?.skipped ? (
                        <td>{data?.examStats?.skipped}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "examResultsDetails" ? (
                      data?.examStats?.marksObtained ? (
                        <td>{data?.examStats?.marksObtained}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "career" || pagename === "Jobs" ? (
                      data?.designation ? (
                        <td>{data?.designation}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "Jobs" ? (
                      data?.company ? (
                        <td>{data?.company}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "career" || pagename === "Jobs" ? (
                      data?.experience ? (
                        <td>{data?.experience}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "career" || pagename === "Jobs" ? (
                      data?.salary ? (
                        <td>{data?.salary}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "career" || pagename === "Jobs" ? (
                      data?.postedOn ? (
                        <td>
                          {moment.utc(data?.postedOn).format("DD-MM-YYYY")}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "EditDeleteResults" ? (
                      data?.firstName || data?.lastName ? (
                        <td>{`${data?.firstName} ${data?.lastName}`}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "EditDeleteResults" ? (
                      data?.rank ? (
                        <td>{data?.rank}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "EditDeleteResults" ? (
                      data?.rollNumber ? (
                        <td>{data?.rollNumber}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "EditDeleteResults" ? (
                      data?.qualifyFor ? (
                        <td>{data?.qualifyFor}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "EditDeleteResults" ? (
                      data?.imageLink ? (
                        <img
                          className="p-1"
                          htmlFor="photo-upload"
                          src={data?.imageLink}
                          style={{
                            width: "50px",
                            height: "50px",
                          }}
                          alt={""}
                        />
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "EditDeleteResults" ? (
                      data?.priorityOrder ? (
                        <td>{data?.priorityOrder}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "DataTeacherRanking" ? (
                      data?.rank ? (
                        <td>{data?.rank}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "DataTeacherRanking" ? (
                      data?.teacherId ? (
                        <td>{data?.teacherId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "DataTeacherRanking" ? (
                      data?.baseCourseId ? (
                        <td>{data?.baseCourseId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "DataTeacherRanking" ? (
                      totalExpectDuration != null ? (
                        <td>
                          {totalExpectDuration} {" Hrs"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "DataTeacherRanking" ? (
                      data?.totalTaskDuration != null ? (
                        <td>
                          {Math.round(data?.totalTaskDuration)?.toFixed(2)}{" "}
                          {" Hrs"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "DataTeacherRanking" ? (
                      data?.totalWorkDuration != null ? (
                        <td>
                          {Math.round(data?.totalWorkDuration)?.toFixed(2)}
                          {" Hrs"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "DataTeacherRanking" ? (
                      data?.totalAvgWorkDuration != null ? (
                        <td>
                          {data?.totalPercentageAchieved
                            ? Math.round(
                                data?.totalPercentageAchieved,
                              )?.toFixed(2)
                            : 0}{" "}
                          %
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* {pagename === "DataTeacherRanking" ? (
                      data?.teacherId != null ? (
                        <>
                          <td>{data?.teacherId?.name}</td>
                          <td>{totalExpectDuration}</td>
                          <td>{getSeconds(data?.taskDuration)}</td>
                          <td>
                            {data?.workDuration
                              ? getSeconds(data?.workDuration)
                              : getSeconds(0)}
                          </td>
                          {/* <td>{getSeconds(data?.taskDuration)}</td>
                          <td>{getSeconds(data?.workDuration)}</td> */}
                    {/* <td
                            style={{
                              fontWeight: "bold",
                              color:
                                (100 *
                                  (data?.workDuration
                                    ? data?.workDuration
                                    : 0)) /
                                  data?.taskDuration >=
                                100
                                  ? "#158833"
                                  : "#F23E36",
                            }}
                          >
                            {data?.workDuration
                              ? `${(
                                  (100 * data?.workDuration) /
                                  data?.taskDuration
                                ).toFixed(2)} %`
                              : "0.00%"} */}
                    {/* {`${(
                            (100 * (data?.workDuration ? data?.workDuration : 0)) /
                            data?.taskDuration
                          ).toFixed(2)} %`} */}
                    {/* </td>
                        </>
                      ) : (
                        <td>-</td>
                      )
                    ) : null} */}
                    {pagename === "teacherPerformance" ? (
                      <>
                        <td>
                          {data?.taskDate
                            ? moment
                                .utc(changeIntoIst(data.taskDate))
                                .format("DD-MM-YYYY")
                            : "-"}
                        </td>
                        <td>{data?.taskType ? data?.taskType : "-"}</td>
                        <td>
                          {data?.examTypeId?.name
                            ? data?.examTypeId?.name
                            : "-"}
                        </td>
                        <td>
                          {data?.baseCourseId?.name
                            ? data?.baseCourseId?.name
                            : "-"}
                        </td>
                        <td>
                          {data?.teacherId?.name ? data?.teacherId?.name : "-"}
                        </td>
                        <td>
                          <a href={data?.link} rel="noreferrer" target="_blank">
                            {data?.link ? data?.link : "-"}
                          </a>
                        </td>
                        {/* <td>
                          {data?.taskDate
                            ? moment(data?.taskDate).format("DD-MM-YYYY")
                            : "-"}
                        </td> */}
                        {/* <td>{data?.taskTitle ? data?.taskTitle : "-"}</td> */}
                        <td>
                          {data?.youtubeDuration ? data?.youtubeDuration : "-"}
                        </td>
                        <td>{data?.viewCount ? data?.viewCount : "-"}</td>
                        <td>{data?.likeCount ? data?.likeCount : "-"}</td>
                        <td>
                          {data?.concurrentCount ? data?.concurrentCount : "-"}
                        </td>
                      </>
                    ) : null}
                    {pagename === "examPopUpNotification" ? (
                      <>
                        <td>
                          {data?.examTypeId?.name
                            ? data?.examTypeId?.name
                            : "-"}
                        </td>
                        <td>
                          {data?.baseCourseId?.name
                            ? data?.baseCourseId?.name
                            : "-"}
                        </td>
                        {/* <td>
                          {data?.notificationText
                            ? data?.notificationText
                            : "-"}
                        </td> */}
                        {/* <td>{data?.isPaidUser ? data?.isPaidUser : "-"}</td> */}
                        <td>{data?.offerMessage ? data?.offerMessage : "-"}</td>
                        <td>{data?.offerMonth ? data?.offerMonth : "-"}</td>
                        <td>{data?.offerPrice ? data?.offerPrice : "-"}</td>
                        <td>
                          {data?.priorityOrder ? data?.priorityOrder : "-"}
                        </td>
                        {/* <td>{data?.url ? data?.url : "-"}</td> */}
                      </>
                    ) : null}
                    {pagename === "campaignPage" ? (
                      <>
                        <td>{data?.campaignName ? data?.campaignName : "-"}</td>
                        <td>
                          {data?.campaigndate
                            ? moment
                                .utc(data?.campaigndate)
                                .format("DD-MM-YYYY")
                            : "-"}
                        </td>
                      </>
                    ) : null}
                    {pagename === "storyTypePage" ? (
                      <>
                        <td>{data?.name ? data?.name : "-"}</td>
                        <td>{data?.icon ? data?.icon : "-"}</td>
                      </>
                    ) : null}
                    {pagename === "teacherPerformanceCxo" ? (
                      <>
                        <td>
                          {data?.taskDate
                            ? moment
                                .utc(changeIntoIst(data.taskDate))
                                .format("DD-MM-YYYY")
                            : "-"}
                        </td>
                        <td>{data?.taskType ? data?.taskType : "-"}</td>
                        <td>
                          {data?.examTypeId?.name
                            ? data?.examTypeId?.name
                            : "-"}
                        </td>
                        <td>
                          {data?.baseCourseId?.name
                            ? data?.baseCourseId?.name
                            : "-"}
                        </td>
                        <td>
                          {data?.teacherId?.name ? data?.teacherId?.name : "-"}
                        </td>
                        <td>
                          <a href={data?.link} rel="noreferrer" target="_blank">
                            {data?.link ? data?.link : "-"}
                          </a>
                        </td>
                        <td>
                          {data?.youtubeDuration ? data?.youtubeDuration : "-"}
                        </td>
                        <td>{data?.viewCount ? data?.viewCount : "-"}</td>
                        <td>{data?.likeCount ? data?.likeCount : "-"}</td>
                        <td>{data?.commentCount ? data?.commentCount : "-"}</td>
                        <td>
                          {data?.favoriteCount ? data?.favoriteCount : "-"}
                        </td>
                      </>
                    ) : null}
                    {pagename === "examWiseAnalysis" ? (
                      <>
                        <td>{data?.examType}</td>
                        <td>{data?.baseCourse}</td>
                        <td>{data?.total}</td>
                      </>
                    ) : null}
                    {pagename === "EditDeleteTeacherTasks" ||
                    pagename === "DisplayTeacherTasksPlan" ||
                    pagename === "TeacherTasksPlan" ||
                    pagename === "DataTeacherTasksPlan" ? (
                      data?.taskDate ? (
                        <td>
                          {moment.utc(data.taskDate).format("DD-MM-YYYY")}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "EditDeleteTeacherTasks" ||
                    pagename === "DisplayTeacherTasksPlan" ||
                    pagename === "TeacherTasksPlan" ||
                    pagename === "DataTeacherTasksPlan" ? (
                      data?.taskType ? (
                        <td>{data?.taskType}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "EditDeleteTeacherTasks" ||
                    pagename === "DisplayTeacherTasksPlan" ||
                    pagename === "TeacherTasksPlan" ||
                    pagename === "DataTeacherTasksPlan" ? (
                      data?.examTypeId ? (
                        <td>{data?.examTypeId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "EditDeleteTeacherTasks" ||
                    pagename === "DisplayTeacherTasksPlan" ||
                    pagename === "TeacherTasksPlan" ||
                    pagename === "DataTeacherTasksPlan" ? (
                      data?.taskTitle != null ? (
                        <td
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "wrap",
                            maxWidth: "20ch",
                          }}
                        >
                          {data?.taskTitle}
                          {data?.classScheduleId ? (
                            <div title="Copy Class Schedule Id">
                              <span
                                className="btn btn-outline-primary"
                                onClick={() =>
                                  copyClassScheduleId(data?.classScheduleId)
                                }
                              >
                                {isCopy ? (
                                  <Tooltip title="Class Schedule Id Copied">
                                    <ContentCopyIcon />
                                  </Tooltip>
                                ) : (
                                  <ContentCopyIcon />
                                )}
                              </span>
                            </div>
                          ) : null}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "EditDeleteTeacherTasks" ||
                    pagename === "DisplayTeacherTasksPlan" ||
                    pagename === "DataTeacherTasksPlan" ? (
                      data?.teacherId != null ? (
                        <td>{data?.teacherId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "EditDeleteTeacherTasks" ||
                    pagename === "DisplayTeacherTasksPlan" ? (
                      data?.taskDate ? (
                        <td>
                          {moment
                            .utc(data.taskDate)
                            .format("DD-MM-YYYY hh:mm:ss")}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "EditDeleteTeacherTasks" ||
                    pagename === "DisplayTeacherTasksPlan" ? (
                      data?.liveStartedAt ? (
                        <td>
                          {moment
                            .utc(data.liveStartedAt)
                            .format("DD-MM-YYYY hh:mm:ss")}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "EditDeleteTeacherTasks" ||
                    pagename === "DisplayTeacherTasksPlan" ? (
                      data?.liveStartedAt ? (
                        DEFICIT(data?.taskDate, data?.liveStartedAt)
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "EditDeleteTeacherTasks" ||
                    pagename === "DisplayTeacherTasksPlan" ||
                    pagename === "TeacherTasksPlan" ||
                    pagename === "DataTeacherTasksPlan" ? (
                      data?.taskDuration != null ? (
                        <td>{getSeconds(data?.taskDuration)}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "EditDeleteTeacherTasks" ||
                    pagename === "DisplayTeacherTasksPlan" ? (
                      data?.remark != null ? (
                        <div className="d-flex align-items-center ">
                          <td
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              maxWidth: "15ch",
                            }}
                          >
                            {data?.remark}
                          </td>
                          {pagename === "EditDeleteTeacherTasks" ? (
                            <span
                              type="submit"
                              className="text-primary fw-bold me-2 cursor"
                              onClick={() => handleViewMore(data)}
                            >
                              View More
                            </span>
                          ) : null}
                        </div>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "DataTeacherTasksPlan" ? (
                      data?.remark != null ? (
                        <td>{data?.remark}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "EditDeleteTeacherTasks" ||
                    pagename === "DisplayTeacherTasksPlan" ||
                    pagename === "TeacherTasksPlan" ||
                    pagename === "DataTeacherTasksPlan" ? (
                      data?.taskType === "PAID_APP_LIVE" ||
                      data?.taskType === "PAID_APP_RECORDED" ? (
                        <td>N/A</td>
                      ) : data?.link || data?.file ? (
                        data?.taskType === "PAID_APP_LIVE" ||
                        data?.taskType === "PAID_APP_RECORDED" ? (
                          <td>N/A</td>
                        ) : (
                          <td
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              maxWidth: "15ch",
                            }}
                          >
                            {data?.link ? (
                              <a
                                href={data?.link}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {data?.link}
                              </a>
                            ) : null}
                            {data?.file ? (
                              <img
                                className="chatimg"
                                src={data?.file}
                                alt={data?.file}
                              />
                            ) : null}
                          </td>
                        )
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/*****************FAQ************** */}
                    {pagename === "courseFAQ" ? (
                      data?.question ? (
                        <td>{data?.question}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "courseFAQ" ? (
                      data?.answer ? (
                        <td>{ReactHtmlParser(data?.answer)}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "EditDeleteTeacherTasks" ||
                    pagename === "DisplayTeacherTasksPlan" ||
                    pagename === "TeacherTasksPlan" ||
                    pagename === "DataTeacherTasksPlan" ? (
                      data?.status ? (
                        <div className="d-flex align-items-center ">
                          <td>
                            {data?.status === 1 ? (
                              <span className="text-warning fw-bold">
                                PENDING
                              </span>
                            ) : data?.status === 2 ? (
                              <span className="text-success fw-bold">
                                COMPLETE
                              </span>
                            ) : data?.status === 3 ? (
                              <span className="text-info fw-bold">
                                MISCELLANEOUS
                              </span>
                            ) : data?.status === 4 ? (
                              <span className="text-primary fw-bold">
                                ON LEAVE
                              </span>
                            ) : data?.status === 5 ? (
                              <span className="text-danger fw-bold">
                                NOT COMPLETED
                              </span>
                            ) : (
                              "-"
                            )}
                          </td>
                          {pagename === "EditDeleteTeacherTasks" ? (
                            <span
                              type="submit"
                              className="text-primary fw-bold me-2 cursor"
                              onClick={() => handleEditBatch(data, data?._id)}
                            >
                              Edit
                            </span>
                          ) : null}
                          {pagename === "DataTeacherTasksPlan" &&
                          data?.status === 1 &&
                          handleEditBatch ? (
                            <span
                              type="submit"
                              className="text-primary fw-bold me-2 cursor"
                              onClick={() => handleEditBatch(data, data?._id)}
                            >
                              Edit
                            </span>
                          ) : null}
                        </div>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* {pagename === "EditDeleteTeacherTasks" ||
                    pagename === "TeacherTasksPlan" ||
                    pagename === "DataTeacherTasksPlan" ? (
                      data?.remark ? (
                        <td>{data?.remark}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null} */}
                    {pagename === "TeacherTasksPlan" ||
                    pagename === "DataTeacherTasksPlan" ? (
                      data?.workDuration != null ? (
                        <td>
                          {data?.workDuration
                            ? getSeconds(data?.workDuration)
                            : "-"}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "DisplayTeacherTasksPlan" ? (
                      <>
                        <td>
                          {data?.workDuration
                            ? getSeconds(data?.workDuration)
                            : "-"}
                        </td>
                      </>
                    ) : null}
                    {pagename === "EditDeleteTeacherTasks" ? (
                      <td>
                        {data?.status === 2 &&
                        data?.taskType?.trim() === "PAID_APP_LIVE" &&
                        (data?.workDuration || 0) <= 0 ? (
                          <Button
                            variant="contained"
                            size="small"
                            color="warning"
                            onClick={() => handleCheck(data)}
                            sx={{
                              minWidth: "auto",
                              px: 1,
                              py: 0.5,
                              fontSize: "11px",
                              borderRadius: "6px",
                              textTransform: "none",
                              boxShadow: "none",
                            }}
                          >
                            <RefreshIcon />
                          </Button>
                        ) : (
                          <div className="d-flex align-items-center gap-2">
                            <span>
                              {data?.workDuration != null
                                ? getSeconds(data?.workDuration)
                                : "-"}
                            </span>

                            <span
                              className="text-primary fw-bold cursor"
                              onClick={() =>
                                handleEditDuration(data, data?._id)
                              }
                            >
                              Edit
                            </span>
                          </div>
                        )}
                      </td>
                    ) : null}
                    {/* {pagename === "EditDeleteTeacherTasks" ? (
                      data?.workDuration != null ? (
                        <>
                          <td>
                            {data?.workDuration
                              ? getSeconds(data?.workDuration)
                              : "-"}
                            <span
                              type="submit"
                              className="text-primary fw-bold me-2 cursor text-center"
                              onClick={() =>
                                handleEditDuration(data, data?._id)
                              }
                            >
                              Edit
                            </span>
                          </td>
                        </>
                      ) : (
                        <td>
                          <span
                            type="submit"
                            className="text-primary fw-bold me-2 cursor"
                            onClick={() => handleEditDuration(data, data?._id)}
                          >
                            Edit
                          </span>
                        </td>
                      )
                    ) : null} */}
                    {pagename === "TeacherTasksPlan" ||
                    pagename === "DataTeacherTasksPlan" ? (
                      data?.remarkBy ? (
                        <td>{data?.remarkBy}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "EditDeleteTeacherTasks" ||
                    pagename === "DisplayTeacherTasksPlan" ? (
                      <td>
                        {data?.remarkBy
                          ? data?.remarkBy
                          : data?.teacherId?.name}
                      </td>
                    ) : null}
                    {pagename === "EditDeleteTeacherTasks" ||
                    pagename === "DisplayTeacherTasksPlan" ||
                    pagename === "DataTeacherTasksPlan" ? (
                      data?.updatedAt ? (
                        <td>
                          {moment
                            .utc(changeIntoIst(data.updatedAt))
                            .format("DD-MM-YYYY hh:mm:ss")}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "serverList" ? (
                      data?.instanceName ? (
                        <td>{data?.instanceName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "serverList" ? (
                      data?.instanceId ? (
                        <td>{data?.instanceId}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "serverList" ? (
                      data?.instanceState ? (
                        <td>{data?.instanceState}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "serverList" ? (
                      data?.region ? (
                        <td>{data?.region}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "serverList" ? (
                      data?.lastUpdateTime ? (
                        <td>{data?.lastUpdateTime}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "serverList" ? (
                      data?.env ? (
                        <td>{data?.env}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "examDetails" ? (
                      data?.examTypeId ? (
                        <td>{data?.examTypeId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "examDetails" ? (
                      data?.heading ? (
                        <td>{data?.heading}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "examDetails" ? (
                      data?.headingBanner ? (
                        <td>
                          <img
                            htmlFor="photo-upload"
                            src={data?.headingBanner}
                            style={{
                              width: "40px",
                              height: "40px",
                            }}
                            alt={""}
                          />
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "examDetails" ? (
                      data?.teacherId ? (
                        <td>{data?.teacherId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "examDetails" ? (
                      data?.teacherURL ? (
                        <td>{data?.teacherURL}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "examDetails" ? (
                      data?.updatedDateByTeacher ? (
                        <td>{data?.updatedDateByTeacher}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "author" ? (
                      data?.name ? (
                        <td>{data?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "author" ? (
                      data?.designation ? (
                        <td>{data?.designation}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "author" ? (
                      data?.uniqueName ? (
                        <td>{data?.uniqueName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "author" ? (
                      data?.uniqueLink ? (
                        <td>{data?.uniqueLink}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "designations" ? (
                      data?.level ? (
                        <td>{data?.level}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* ********************************************* */}
                    {pagename === "facebookGroupList" ? (
                      <>
                        <td>
                          {data?.createdAt
                            ? moment(data?.createdAt).format("DD-MM-YYYY")
                            : "-"}
                        </td>
                        <td>
                          {data?.examTypeId ? data?.examTypeId?.name : "-"}
                        </td>
                        <td>
                          {data?.baseCourseId ? data?.baseCourseId?.name : "-"}
                        </td>
                        <td>{data?.groupName ? data?.groupName : "-"}</td>
                        <td>
                          <Link target="_blank" to={data?.groupUrl}>
                            {data?.groupUrl ? "Link" : "-"}
                          </Link>
                        </td>
                        <td>
                          {data?.groupType === 2
                            ? "Private"
                            : data?.groupType === 3
                              ? "Member"
                              : "Public"}
                        </td>
                        <td>
                          {data?.groupStatus === 2
                            ? "Approval"
                            : data?.groupStatus === 3
                              ? "Reject"
                              : "Pending"}
                        </td>
                        <td>
                          {data?.status === 2
                            ? "Approval By Manager"
                            : data?.status === 3
                              ? "Reject By Manager"
                              : data?.status === 9
                                ? "Deleted By User"
                                : "Pending By Manager"}
                        </td>
                      </>
                    ) : null}
                    {pagename === "facebookGroupListManager" ? (
                      <>
                        <td>
                          {data?.createdAt
                            ? moment(data?.createdAt).format("DD-MM-YYYY")
                            : "-"}
                        </td>
                        <td>
                          {data?.examTypeId ? data?.examTypeId?.name : "-"}
                        </td>
                        <td>
                          {data?.baseCourseId ? data?.baseCourseId?.name : "-"}
                        </td>
                        <td>{data?.groupName ? data?.groupName : "-"}</td>
                        <td>
                          <Link target="_blank" to={data?.groupUrl}>
                            {data?.groupUrl ? data?.groupUrl : "-"}
                          </Link>
                        </td>
                        <td>
                          {data?.groupType === 2
                            ? "Private"
                            : data?.groupType === 3
                              ? "Member"
                              : "Public"}
                        </td>
                        <td>
                          {data?.groupStatus === 2
                            ? "Approval"
                            : data?.groupStatus === 3
                              ? "Reject"
                              : "Pending"}
                        </td>
                        <td>
                          {data?.status === 2
                            ? "Approval By Manager"
                            : data?.status === 3
                              ? "Reject By Manager"
                              : data?.status === 9
                                ? "Deleted By User"
                                : "Pending By Manager"}
                        </td>
                      </>
                    ) : null}
                    {pagename === "revenueDataList" ||
                    pagename === "revenueStateDataList" ? (
                      data?._id ? (
                        <td>{data?._id}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {transactionType?._id === 2 ? (
                      pagename === "revenueDataList" ||
                      pagename === "revenueStateDataList" ? (
                        data?.publication >= 0 ? (
                          <td>
                            {"\u20B9"}
                            {data?.publication?.toFixed(2)}
                          </td>
                        ) : (
                          <td>-</td>
                        )
                      ) : null
                    ) : null}
                    {transactionType?._id === 3 ? (
                      pagename === "revenueDataList" ||
                      pagename === "revenueStateDataList" ? (
                        data?.shopifyRevenue >= 0 ? (
                          <td>
                            {"\u20B9"}
                            {data?.shopifyRevenue?.toFixed(2)}
                          </td>
                        ) : (
                          <td>-</td>
                        )
                      ) : null
                    ) : null}
                    {transactionType?._id === 1 ? (
                      <>
                        {pagename === "revenueDataList" ||
                        pagename === "revenueStateDataList" ? (
                          data?.actualTotalAmount >= 0 ? (
                            <td>
                              {"\u20B9"}
                              {data?.actualTotalAmount?.toFixed(2)}
                            </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "revenueDataList" ||
                        pagename === "revenueStateDataList" ? (
                          data?.totalGstAmount >= 0 ? (
                            <td>
                              {"\u20B9"}
                              {data?.totalGstAmount?.toFixed(2)}
                            </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                      </>
                    ) : null}
                    {pagename === "revenueDataList" ||
                    pagename === "revenueStateDataList" ? (
                      data ? (
                        <td>
                          {"\u20B9"}
                          {data?.totalAmount}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {/* {pagename === "revenueDataList" ||
                    pagename === "revenueStateDataList" ? (
                      data ? (
                        <td>
                          {transactionType?._id === 1
                            ? (
                                (data?.actualTotalAmount?.toFixed(2) /
                                  totalRevenue) *
                                100
                              )?.toFixed(2)
                            : transactionType?._id === 2
                            ? data?.publication > 0
                              ? (
                                  (data?.publication?.toFixed(2) /
                                    totalRevenue) *
                                  100
                                )?.toFixed(2)
                              : 0
                            : transactionType?._id === 3
                            ? (
                                (data?.shopifyRevenue?.toFixed(2) /
                                  totalRevenue) *
                                100
                              )?.toFixed(2)
                            : 0}{" "}
                          %
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null} */}
                    {pagename === "revenueDataList" ||
                    pagename === "revenueStateDataList" ? (
                      data ? (
                        <td>
                          {transactionType?._id === 1
                            ? !data?.actualTotalAmount
                              ? 0
                              : (
                                  (Number(data?.actualTotalAmount?.toFixed(2)) /
                                    totalRevenue) *
                                  100
                                )?.toFixed(2)
                            : transactionType?._id === 2
                              ? !data?.publication
                                ? 0
                                : (
                                    (Number(data?.publication?.toFixed(2)) /
                                      totalRevenue) *
                                    100
                                  )?.toFixed(2)
                              : transactionType?._id === 3
                                ? !data?.shopifyRevenue
                                  ? 0
                                  : (
                                      (Number(
                                        data?.shopifyRevenue?.toFixed(2),
                                      ) /
                                        totalRevenue) *
                                      100
                                    )?.toFixed(2)
                                : 0}{" "}
                          %
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "baseOffer" ? (
                      data?.examTypeId ? (
                        <td>{data?.examTypeId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "baseOffer" ? (
                      data?.baseCourseId ? (
                        <td>{data?.baseCourseId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "baseOffer" ? (
                      data?.sectionType ? (
                        <td>{data?.sectionType?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "baseOffer" ? (
                      data?.subCategoryId ? (
                        <td>{data?.subCategoryId?.name}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "baseOffer" ? (
                      data?.discPer ? (
                        <td>{data?.discPer}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "UpcomingBatchesEdit" ? (
                      <>
                        <td>
                          {data?.examTypeId?.name
                            ? data?.examTypeId?.name
                            : "-"}
                        </td>
                        <td>
                          {data?.baseCourseId.name
                            ? data?.baseCourseId.name
                            : "-"}
                        </td>
                        <td style={{ maxWidth: "200px" }}>
                          {data?.upcomingBatchName && data?.upcomingBatchName}
                        </td>
                        <td style={{ width: "100px" }}>
                          {data?.batchDate &&
                            moment.utc(data.batchDate).format("DD-MM-YYYY")}
                        </td>
                        <td>
                          {data?.admissionTarget && data?.admissionTarget}
                        </td>
                      </>
                    ) : null}
                    {pagename === "BatchaAnalisis" ? (
                      <>
                        <td key={data._id}>{data.examType && data.examType}</td>
                        <td>{data?.baseCourse ? data?.baseCourse : "-"}</td>
                        <td>
                          {data?.upcomingBatchName && data?.upcomingBatchName}
                        </td>
                        <td>
                          {data?.batchDate &&
                            moment.utc(data.batchDate).format("DD-MM-YYYY")}
                        </td>
                        <td>
                          {data?.admissionTarget && data?.admissionTarget}
                        </td>
                        <td>{data?.deficit && data?.deficit}</td>
                        <td>
                          {data?.percentageAchieved && data?.percentageAchieved}
                        </td>
                      </>
                    ) : null}
                    {pagename === "CreatePublicationVendor" ? (
                      <>
                        <td key={data._id}>
                          {data.gstNumber && data.gstNumber}
                        </td>
                        <td>{data?.companyName ? data?.companyName : "-"}</td>
                        <td>{data?.contactPerson?.name}</td>
                        <td>{data?.contactNo}</td>
                        <td>{data?.PAN}</td>
                        <td>{data?.stateId?.name}</td>
                        <td>{data?.cityId?.name}</td>
                        {data?.service?.map((item) => (
                          <tr className="bg-transparent">
                            <td>{item?.serviceName}</td>
                          </tr>
                        ))}
                      </>
                    ) : null}
                    {pagename === "oldUrlRedirection" ? (
                      <>
                        <td key={data._id}>{data?.oldUrl}</td>
                        <td>{data.newUrl}</td>
                      </>
                    ) : null}
                    {pagename === "OrderAnalysis" ? (
                      <>
                        <td>
                          {data.registrationDate &&
                            moment
                              .utc(data.registrationDate)
                              .format("DD-MM-YYYY")}
                        </td>
                        <td>{data?.registration ? data?.registration : "-"}</td>
                        <td>{data?.paidUsers ? data?.paidUsers : 0} </td>
                        <td>{data?.edutech ? data?.edutech : 0} </td>
                        <td>{data?.counsellor ? data?.counsellor : 0} </td>
                        <td>{data?.outgoing ? data?.outgoing : 0} </td>
                        <td>{data?.incoming ? data?.incoming : 0} </td>
                        <td>{data?.publication ? data?.publication : 0} </td>
                        <td>{data?.student ? data?.student : 0} </td>
                        <td>{data?.refer ? data?.refer : 0} </td>
                        <td>{data?.influencer ? data?.influencer : 0} </td>
                        <td>{data?.pamplet ? data?.pamplet : 0} </td>
                        <td>{data?.teacher ? data?.teacher : 0} </td>
                        <td>
                          {data?.withoutCoupon ? data?.withoutCoupon : "-"}
                        </td>
                        <td>{data?.couponNames ? data?.couponNames : "-"}</td>
                        <td>{data?.source ? data?.source : "-"}</td>
                        <td>
                          {data?.student
                            ? (
                                (data?.student?.toFixed(2) / data?.paidUsers) *
                                100
                              )?.toFixed(2)
                            : 0}{" "}
                        </td>
                        <td>
                          {data?.paidUsers
                            ? (
                                (data?.paidUsers?.toFixed(2) /
                                  data?.registration) *
                                100
                              )?.toFixed(2)
                            : 0}{" "}
                        </td>
                      </>
                    ) : null}
                    {/* ******************************damageStock************************* */}
                    {pagename === "damageStock" ? (
                      data?.bookName ? (
                        <td>{data?.bookName}</td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "damageStock" ? (
                      data?.addedDate ? (
                        <td>
                          {moment.utc(data?.addedDate).format("DD-MM-YYYY")}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "damageStock" ? (
                      data?.lastQuantity ? (
                        <td>{data?.lastQuantity}</td>
                      ) : (
                        <td>0</td>
                      )
                    ) : null}
                    {pagename === "damageStock" ? (
                      data?.currentQuantity ? (
                        <td>{data?.currentQuantity}</td>
                      ) : (
                        <td>0</td>
                      )
                    ) : null}
                    {pagename === "damageStock" ? (
                      data?.quantity ? (
                        <td>{data?.quantity}</td>
                      ) : (
                        <td>0</td>
                      )
                    ) : null}
                    {pagename === "gifNotification" ? (
                      <>
                        <td key={data?._id}>
                          {(
                            <img
                              src={data?.file}
                              height={50}
                              width={60}
                              alt="Gif"
                            />
                          ) || "-"}
                        </td>
                        <td>
                          {data?.baseCourses?.name
                            ? data?.baseCourses?.name
                            : "-"}
                        </td>
                        <td>{data?.teachers?.name || "-"}</td>
                        <td>{data?.sections?.name || "-"}</td>
                        <td>{data?.subCategories?.name || "-"}</td>
                        <td>{data?.notificationTypes?.name || "-"}</td>
                      </>
                    ) : null}
                    {pagename === "allPopUp" ? (
                      <>
                        <td>{data?.examTypeId?.name || "-"}</td>
                        <td>{data?.baseCourseId?.name || "-"}</td>
                        <td>{data?.subExamTypeId?.name || "-"}</td>
                        <td>{data?.stateId?.name || "-"}</td>
                        <td>{data?.gender || "-"}</td>
                        <td>{data?.type || "-"}</td>
                        <td>{data?.text || "-"}</td>
                        <td>{data?.priorityOrder || "-"}</td>
                      </>
                    ) : null}
                    {/* ******************************PubBookHistory************************* */}
                    {pagename === "PubBookHistory" ? (
                      <>
                        <td>{data?.addedBy?.name}</td>
                        <td>
                          {moment
                            .utc(data?.addedDate)
                            .format("DD-MM-YYYY , hh:mm A")}
                        </td>
                        <td>{data?.lastQuantity || 0}</td>
                        <td>{data?.currentlyQuantity || 0}</td>
                        <td>{data?.quantity || 0}</td>
                        <td>
                          {data?.status === 1
                            ? "Stock In"
                            : data?.status === 2
                              ? "Shift/Transfer"
                              : data?.status === 3
                                ? "Order Return"
                                : data?.status === 4
                                  ? "Damage"
                                  : data?.status === 5
                                    ? "Sell"
                                    : "-"}
                        </td>
                        <td>{data?.from || "-"}</td>
                        <td>{data?.to || "-"}</td>
                        <td>{data?.sourceDetails?.name || "-"}</td>
                      </>
                    ) : null}
                    {/* ******************************Cxo Publication BookOrderHistory************************* */}
                    {pagename === "BookOrderHistory" ? (
                      data?.examTypeId ? (
                        <td className="">{data?.examTypeId?.name}</td>
                      ) : (
                        <td className="">-</td>
                      )
                    ) : null}
                    {pagename === "BookOrderHistory" ? (
                      data?.subExamTypeId ? (
                        <td className="">{data?.subExamTypeId?.name}</td>
                      ) : (
                        <td className="">-</td>
                      )
                    ) : null}
                    {pagename === "BookOrderHistory" ? (
                      data?.baseCourseId ? (
                        <td className="">{data?.baseCourseId?.name}</td>
                      ) : (
                        <td className="">-</td>
                      )
                    ) : null}
                    {pagename === "BookOrderHistory" ? (
                      data?.title ? (
                        <td className="">{data?.title[0]}</td>
                      ) : (
                        <td className="">-</td>
                      )
                    ) : null}
                    {pagename === "BookOrderHistory" ? (
                      data?.subCategory ? (
                        <td className="">{data?.subCategory}</td>
                      ) : (
                        <td className="">-</td>
                      )
                    ) : null}
                    {pagename === "BookOrderHistory" ? (
                      data?.count ? (
                        <td className="">{data?.count}</td>
                      ) : (
                        <td className="">-</td>
                      )
                    ) : null}
                    {pagename === "BookOrderHistory" ? (
                      data?.amount ? (
                        <td className="">{data?.amount}</td>
                      ) : (
                        <td className="">-</td>
                      )
                    ) : null}
                    {/* ******************************Cxo Publication BookHistory************************* */}
                    {pagename === "SellingSrcRevenueAnalysis" ? (
                      data?.examTypeId ? (
                        <td className="">{data?.examTypeId?.name}</td>
                      ) : (
                        <td className="">-</td>
                      )
                    ) : null}
                    {pagename === "SellingSrcRevenueAnalysis" ? (
                      data?.baseCourseId ? (
                        <td className="">{data?.baseCourseId?.name}</td>
                      ) : (
                        <td className="">-</td>
                      )
                    ) : null}
                    {pagename === "SellingSrcRevenueAnalysis" ? (
                      data?.addedDate ? (
                        <td>
                          {moment
                            .utc(data?.addedDate)
                            .format("DD-MM-YYYY, hh:mm A")}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "SellingSrcRevenueAnalysis" ? (
                      data?.totalQuantity ? (
                        <td className="">{data?.totalQuantity}</td>
                      ) : (
                        <td className="">-</td>
                      )
                    ) : null}
                    {pagename === "SellingSrcRevenueAnalysis" ? (
                      data?.totalAmount ? (
                        <td className="">{data?.totalAmount}</td>
                      ) : (
                        <td className="">-</td>
                      )
                    ) : null}
                    {/* ******************************sELLING SOURCE REVENUE************************* */}
                    {pagename === "SellingSrcAnalysis" ? (
                      data?.sourceName ? (
                        <td className="">{data?.sourceName}</td>
                      ) : (
                        <td className="">-</td>
                      )
                    ) : null}
                    {pagename === "SellingSrcAnalysis" ? (
                      data?.quantity ? (
                        <td className="">{data?.quantity}</td>
                      ) : (
                        <td className="">-</td>
                      )
                    ) : null}
                    {pagename === "SellingSrcAnalysis" ? (
                      data?.amount ? (
                        <td className="">{data?.amount}</td>
                      ) : (
                        <td className="">-</td>
                      )
                    ) : null}
                    {pagename === "SellingSrcAnalysis" ? (
                      data?.contributionPer ? (
                        <td className="">{data?.contributionPer} %</td>
                      ) : (
                        <td className="">-</td>
                      )
                    ) : null}
                    {/* *****************************************************transaction edutech tech support******************************************************* */}
                    {pagename === "transactionEdutechTechSupport" &&
                      (data ? (
                        <>
                          <td>{data?.orderNo}</td>
                          <td>
                            {moment.utc(data.date).format("DD-MM-YYYY ; LT")}
                          </td>
                          {/* <td>{data?.userDetails?.mobileNo}</td> */}
                          <td>{getBatchName(data?.courses)}</td>
                          <td>{getSubscriptionMonths(data?.courses)}</td>
                          <td>{getActualPrice(data?.courses)}</td>
                          <td>{getGSTPrice(data?.courses)}</td>
                          <td>{getEdutechTotalPrice(data?.courses)}</td>
                          {/* <td>{getCoupon(data?.courses)}</td> */}
                          <td>{getDiscountedValue(data?.courses)}</td>
                          <td>
                            {data?.status !== 2 ? (
                              <span
                                type="button"
                                className="text-primary fw-bold me-2 cursor"
                                onClick={() => handleViewMore(data)}
                              >
                                View
                              </span>
                            ) : null}
                          </td>
                          {/* <td>{data?.paymentGatewayResponse[0]?.status}</td>
                          <td>
                            {data?.status === 0
                              ? "Created"
                              : data?.status === 1
                              ? "In Progress"
                              : data?.status === 2
                              ? "Successful"
                              : data?.status === 9
                              ? "Cancelled"
                              : "-"}
                          </td> */}
                        </>
                      ) : (
                        <td>-</td>
                      ))}
                    {/* ***********************talkTimeAnalysis***************** */}
                    {pagename === "talkTimeAnalysis" ? (
                      <td className="p-3"> {data.name ? data.name : "-"}</td>
                    ) : null}
                    {pagename === "talkTimeAnalysis" ? (
                      <td className="p-3"> {data?.totalTime}</td>
                    ) : null}
                    {pagename === "talkTimeAnalysis" ? (
                      <td className="p-3">
                        {" "}
                        {data.talkTime_min[0]?.time_7AM_8AM
                          ? data.talkTime_min[0]?.time_7AM_8AM
                          : 0}
                      </td>
                    ) : null}
                    {pagename === "talkTimeAnalysis" ? (
                      <td className="p-3">
                        {" "}
                        {data.talkTime_min[1]?.time_8AM_9AM
                          ? data.talkTime_min[1]?.time_8AM_9AM
                          : 0}
                      </td>
                    ) : null}
                    {pagename === "talkTimeAnalysis" ? (
                      <td className="p-3">
                        {" "}
                        {data.talkTime_min[2]?.time_9AM_10AM
                          ? data.talkTime_min[2]?.time_9AM_10AM
                          : 0}
                      </td>
                    ) : null}
                    {pagename === "talkTimeAnalysis" ? (
                      <td className="p-3">
                        {" "}
                        {data.talkTime_min[3]?.time_10AM_11AM
                          ? data.talkTime_min[3]?.time_10AM_11AM
                          : 0}
                      </td>
                    ) : null}
                    {pagename === "talkTimeAnalysis" ? (
                      <td className="p-3">
                        {" "}
                        {data.talkTime_min[4]?.time_11AM_12PM
                          ? data.talkTime_min[4]?.time_11AM_12PM
                          : 0}
                      </td>
                    ) : null}
                    {pagename === "talkTimeAnalysis" ? (
                      <td className="p-3">
                        {" "}
                        {data.talkTime_min[5]?.time_12PM_1PM
                          ? data.talkTime_min[5]?.time_12PM_1PM
                          : 0}
                      </td>
                    ) : null}
                    {pagename === "talkTimeAnalysis" ? (
                      <td className="p-3">
                        {" "}
                        {data.talkTime_min[6]?.time_1PM_2PM
                          ? data.talkTime_min[6]?.time_1PM_2PM
                          : 0}
                      </td>
                    ) : null}
                    {pagename === "talkTimeAnalysis" ? (
                      <td className="p-3">
                        {" "}
                        {data.talkTime_min[7]?.time_2PM_3PM
                          ? data.talkTime_min[7]?.time_2PM_3PM
                          : 0}
                      </td>
                    ) : null}
                    {pagename === "talkTimeAnalysis" ? (
                      <td className="p-3">
                        {" "}
                        {data.talkTime_min[8]?.time_3PM_4PM
                          ? data.talkTime_min[8]?.time_3PM_4PM
                          : 0}
                      </td>
                    ) : null}
                    {pagename === "talkTimeAnalysis" ? (
                      <td className="p-3">
                        {" "}
                        {data.talkTime_min[9]?.time_4PM_5PM
                          ? data.talkTime_min[9]?.time_4PM_5PM
                          : 0}
                      </td>
                    ) : null}
                    {pagename === "talkTimeAnalysis" ? (
                      <td className="p-3">
                        {" "}
                        {data.talkTime_min[10]?.time_5PM_6PM
                          ? data.talkTime_min[10]?.time_5PM_6PM
                          : 0}
                      </td>
                    ) : null}
                    {pagename === "talkTimeAnalysis" ? (
                      <td className="p-3">
                        {" "}
                        {data.talkTime_min[11]?.time_6PM_7PM
                          ? data.talkTime_min[11]?.time_6PM_7PM
                          : 0}
                      </td>
                    ) : null}
                    {pagename === "talkTimeAnalysis" ? (
                      <td className="p-3">
                        {" "}
                        {data.talkTime_min[12]?.time_7PM_8PM
                          ? data.talkTime_min[12]?.time_7PM_8PM
                          : 0}
                      </td>
                    ) : null}
                    {pagename === "talkTimeAnalysis" ? (
                      <td className="p-3">
                        {" "}
                        {data.talkTime_min[13]?.time_8PM_9PM
                          ? data.talkTime_min[13]?.time_8PM_9PM
                          : 0}
                      </td>
                    ) : null}
                    {pagename === "talkTimeAnalysis" ? (
                      <td className="p-3">
                        {" "}
                        {data.talkTime_min[14]?.time_9PM_10PM
                          ? data.talkTime_min[14]?.time_9PM_10PM
                          : 0}
                      </td>
                    ) : null}
                    {pagename === "talkTimeAnalysis" ? (
                      <td className="p-3">
                        {" "}
                        {data.talkTime_min[15]?.time_10PM_11PM
                          ? data.talkTime_min[15]?.time_10PM_11PM
                          : 0}
                      </td>
                    ) : null}
                    {pagename === "talkTimeAnalysis" ? (
                      <td className="p-3">
                        {" "}
                        {data.talkTime_min[16]?.time_11PM_12AM
                          ? data.talkTime_min[16]?.time_11PM_12AM
                          : 0}
                      </td>
                    ) : null}

                    {pagename === "WhatappDataAnalysis" ? (
                      <>
                        <td>{data?.typeName ? data?.typeName : "-"}</td>
                        <td>{data?.totalCount ? data?.totalCount : "0"}</td>
                        <td>
                          {data?.isWhatsAppCount ? data?.isWhatsAppCount : "0"}
                        </td>
                        <td>
                          {data?.isNotWhatsAppCount
                            ? data?.isNotWhatsAppCount
                            : "0"}
                        </td>
                        <td>
                          {data?.notUpdatedCount ? data?.notUpdatedCount : "0"}
                        </td>
                        <td>{data?.OptedInCount ? data?.OptedInCount : "0"}</td>
                        <td>
                          {data?.OptedOutCount ? data?.OptedOutCount : "0"}
                        </td>
                        <td>{data?.BlockedCount ? data?.BlockedCount : "0"}</td>
                        <td>
                          {data?.UndeliverableCount
                            ? data?.UndeliverableCount
                            : "0"}
                        </td>
                      </>
                    ) : null}
                    {pagename === "videoAnalysisCount" ? (
                      <>
                        <td>{data?._id || "-"}</td>
                        <td>{data?.firstName || "-"}</td>
                        <td>{data?.lastName || "-"}</td>
                      </>
                    ) : null}
                    {pagename === "editAppFeature" ? (
                      <>
                        <td>{data?.device || "-"}</td>
                        <td>
                          {data?.image ? (
                            <ImagePickerAndViewer
                              value={data?.image}
                              disabled
                            />
                          ) : null}
                        </td>
                        <td>{data?.order || "-"}</td>
                        <td>{data?.title || "-"}</td>
                        <td>{data?.videoUrl || "-"}</td>
                      </>
                    ) : null}
                    {pagename === "userKyc" ? (
                      <>
                        <td>
                          {data?.aadharNo
                            ? data.aadharNo?.slice(0, 2) +
                              "X".repeat(data.aadharNo.length - 6) +
                              data.aadharNo?.slice(-2)
                            : "-"}
                        </td>

                        <td>{`${data?.firstName || "-"} ${
                          data?.lastName || "-"
                        }`}</td>
                        <td>{data?.gender || "-"}</td>
                        <td>
                          {data?.status === 0 ? (
                            <span className="badge bg-warning text-dark">
                              Pending
                            </span>
                          ) : data?.status === 1 ? (
                            <span className="badge bg-success">Approved</span>
                          ) : data?.status === 2 ? (
                            <span className="badge bg-danger">Rejected</span>
                          ) : (
                            "-"
                          )}
                        </td>

                        {/* <td>{data?.mobileNo || "-"}</td> */}
                        {/* <td>
                          {data?.aadharCardFront ? (
                            <ImagePickerAndViewer
                              value={data?.aadharCardFront}
                              disabled
                            />
                          ) : null}
                        </td> */}
                        {/* <td>
                          {data?.aadharCardBack ? (
                            <ImagePickerAndViewer
                              value={data?.aadharCardBack}
                              disabled
                            />
                          ) : null}
                        </td> */}
                      </>
                    ) : null}

                    {pagename === "UserActivityDetails" ? (
                      data?.url ? (
                        <td className="text-break  ">
                          {data?.url.split("/").join(" -> ")}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}
                    {pagename === "UserActivityDetails" ? (
                      data?.date ? (
                        <td className="text-break  ">
                          {" "}
                          {moment(data?.date).utc().format("LTS")}
                        </td>
                      ) : (
                        <td>-</td>
                      )
                    ) : null}

                    {pagename === "EditDeleteTeacherTasks" &&
                    role === "HOD" ? null : (
                      <td>
                        {addOnButton ? (
                          <>
                            {pagename === "bookhistory" &&
                            data?.status === 9 ? (
                              <span
                                className="text-danger fw-bold me-2 cursor"
                                onClick={() => handleAddOnButton(data)}
                              >
                                Entry Deleted
                              </span>
                            ) : (
                              <>
                                <span
                                  type="submit"
                                  className={className}
                                  onClick={() => handleAddOnButton(data)}
                                >
                                  {addOnButtonLabel}{" "}
                                </span>
                                {adddeleteButton ? (
                                  <span
                                    type="submit"
                                    className="text-danger fw-bold cursor"
                                    onClick={() => handleDelete(data)}
                                  >
                                    Delete
                                  </span>
                                ) : null}
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            {edit ? (
                              pagename === "userFeedBack" ||
                              pagename === "examResults" ||
                              pagename === "courseFeedBack" ||
                              pagename === "batchwiseCount" ||
                              pagename === "cxoBatchWiseCount" ||
                              pagename === "academicBatchWiseCount" ||
                              pagename === "studentCount" ||
                              pagename === "serverList" ||
                              pagename === "referenceLeadCount" ||
                              pagename === "referenceTeamLeadCount" ||
                              pagename === "stockAnalysis" ||
                              pagename === "onboardingForm" ||
                              pagename === "classroomStudents" ? (
                                <span
                                  type="submit"
                                  className="text-success me-2 fw-bold cursor"
                                  onClick={() => handleEdit(data)}
                                >
                                  View Details
                                </span>
                              ) : (
                                <span
                                  type="submit"
                                  className="text-primary fw-bold me-2 cursor"
                                  onClick={() => handleEdit(data)}
                                >
                                  Edit
                                </span>
                              )
                            ) : null}
                            {pagename === "finTransEductech" ? (
                              <span
                                type="submit"
                                className="fw-bold cursor"
                                style={{ color: "green" }}
                                onClick={() => handleRefund(data)}
                              >
                                Refund Amount
                              </span>
                            ) : null}
                            {pagename !== "classroomStudents" &&
                            pagename !== "userFeedBack" &&
                            pagename !== "courseFeedBack" &&
                            pagename !== "importRecVideoLectList" &&
                            pagename !== "TeacherHoursList" &&
                            pagename !== "transactionPublication" &&
                            pagename !== "transactionEdutech" &&
                            pagename !== "totalRevenue" &&
                            pagename !== "influencerRank" &&
                            pagename !== "transactionEdutechVP" &&
                            pagename !== "transactionEdutechStudyMaterialVP" &&
                            pagename !== "transactionEdutechStudyMaterial" &&
                            pagename !== "studyMaterialOrders" &&
                            pagename !== "AllDetailsSMOrders" &&
                            pagename !== "revenueDetails" &&
                            pagename !== "batchwiseCount" &&
                            pagename !== "datewiseCount" &&
                            pagename !== "admissionHistory" &&
                            pagename !== "studentCount" &&
                            pagename !== "registrationDetails" &&
                            pagename !== "dataRegistrationDetails" &&
                            pagename !== "examResults" &&
                            pagename !== "examResultsDetails" &&
                            pagename !== "TeacherTasksPlan" &&
                            pagename !== "DataTeacherTasksPlan" &&
                            pagename !== "counsellorCouponCode" &&
                            pagename !== "publiCounsellorCouponCode" &&
                            pagename !== "serverList" &&
                            pagename !== "stateStudentCount" &&
                            pagename !== "DataTeacherRanking" &&
                            pagename !== "editSyllabusList" &&
                            pagename !== "viewSyllabusList" &&
                            pagename !== "paymentPublication" &&
                            pagename !== "referenceLeadCount" &&
                            pagename !== "referenceTeamLeadCount" &&
                            pagename !== "teacherPerformance" &&
                            pagename !== "teacherPerformanceCxo" &&
                            pagename !== "examWiseAnalysis" &&
                            pagename !== "referenceGenerated" &&
                            pagename !== "finTransEductech" &&
                            pagename !== "whatsappShoot" &&
                            pagename !== "assetList" &&
                            pagename !== "cxoBatchWiseCount" &&
                            pagename !== "academicBatchWiseCount" &&
                            pagename !== "cxoBatchWiseCountDetail" &&
                            pagename !== "copyCounsellorCode" &&
                            pagename !== "inventoryManagement" &&
                            pagename !== "competitor" &&
                            pagename !== "revenueDataList" &&
                            pagename != "BatchaAnalisis" &&
                            pagename != "UpcomingBatchesEdit" &&
                            pagename !== "revenueStateDataList" &&
                            pagename !== "baseOffer" &&
                            pagename !== "incentiveRevenue" &&
                            pagename !== "influencerList" &&
                            pagename !== "influencerPayList" &&
                            pagename !== "refundTransactions" &&
                            pagename !== "revenueData" &&
                            pagename !== "referenceTarget" &&
                            pagename !== "facebookGroupListManager" &&
                            pagename !== "stockAnalysis" &&
                            pagename !== "damageStock" &&
                            pagename !== "PubstockAnalysis" &&
                            pagename !== "PubBookHistory" &&
                            pagename !== "transactionEdutechTechSupport" &&
                            pagename !==
                              "transactionEdutechStudyMaterialTechSupport" &&
                            pagename !== "onboardingForm" &&
                            pagename !== "SellingSrcAnalysis" &&
                            pagename !== "SellingSrcRevenueAnalysis" &&
                            pagename !== "OrderAnalysis" &&
                            pagename !== "BookOrderHistory" &&
                            pagename !== "talkTimeAnalysis" &&
                            pagename !== "WhatappMessageNotSend" &&
                            pagename !== "WhatappMessageAnalysis" &&
                            pagename !== "DisplayTeacherTasksPlan" &&
                            pagename !== "AddOnAnalysis" &&
                            pagename !== "CrossSellingAnalysis" &&
                            pagename !== "CancelledAnalysis" &&
                            pagename !== "videoAnalysisCount" &&
                            pagename !== "storyTypePage" &&
                            pagename !== "WhatappDataAnalysis" &&
                            pagename !== "viewQuestion" &&
                            pagename !== "quizConfigList" &&
                            pagename !== "editNotes" &&
                            pagename !== "UserActivityDetails" ? (
                              <span
                                type="submit"
                                className="text-danger fw-bold cursor"
                                onClick={() => {
                                  setDeletePopup(true);
                                  let deleteDataName = "";
                                  {
                                    pagename === "ExamName" ||
                                    pagename === "gifNotification" ||
                                    pagename === "SubExam" ||
                                    pagename === "ParentCourse" ||
                                    pagename === "Language" ||
                                    pagename === "subCatagory1" ||
                                    pagename === "subCatagory2" ||
                                    pagename === "subCatagory3" ||
                                    pagename === "subject" ||
                                    pagename === "maincategory" ||
                                    pagename === "section" ||
                                    pagename === "assignbooks" ||
                                    pagename === "packageExtend" ||
                                    pagename === "editPattern" ||
                                    pagename === "couponCode" ||
                                    pagename === "edutechCounsellorCode" ||
                                    pagename === "publicationCounsellorCode" ||
                                    pagename === "counsellorCode" ||
                                    pagename === "BBmeeting" ||
                                    pagename === "batchType" ||
                                    pagename === "SopPpt" ||
                                    pagename === "topic" ||
                                    pagename === "subTopic" ||
                                    pagename === "lecture" ||
                                    pagename === "editPattern" ||
                                    pagename === "publiCounsellorCode" ||
                                    pagename === "books" ||
                                    pagename === "IssueType" ||
                                    pagename === "subDepartment" ||
                                    pagename === "author" ||
                                    pagename === "company" ||
                                    pagename === "department" ||
                                    pagename === "designations" ||
                                    pagename === "dummyAccountData" ||
                                    pagename === "sourceNameList" ||
                                    pagename === "editTdsList"
                                      ? (deleteDataName = data?.name)
                                      : pagename === "bannertype" ||
                                          pagename === "courseType"
                                        ? (deleteDataName = data?.type)
                                        : pagename === "teacherLecture" ||
                                            pagename === "editLiveVideo" ||
                                            pagename ===
                                              "editLivePremierVideo" ||
                                            pagename === "notificationList" ||
                                            pagename === "seoBlogs" ||
                                            pagename === "youtubelive" ||
                                            pagename === "youtubeRecorded"
                                          ? (deleteDataName = data?.title)
                                          : pagename === "editLiveFreeVideo"
                                            ? (deleteDataName =
                                                data?.lectureTitle)
                                            : pagename ===
                                                "liveRecVideoLectList"
                                              ? (deleteDataName =
                                                  data?.lectureTitle)
                                              : pagename ===
                                                  "packageExtendAndUpgrade"
                                                ? (deleteDataName =
                                                    data?.sectionId?.name)
                                                : pagename === "assignTeacher"
                                                  ? (deleteDataName =
                                                      data?.teacherId?.name)
                                                  : pagename ===
                                                      "EditDeleteTeacherTasks"
                                                    ? (deleteDataName =
                                                        data?.taskTitle)
                                                    : pagename ===
                                                        "copyPackageList"
                                                      ? (deleteDataName =
                                                          data?.toCourseId
                                                            ?.name)
                                                      : pagename ===
                                                          "examSyllabus"
                                                        ? (deleteDataName =
                                                            data?.subjectName)
                                                        : pagename ===
                                                            "EditDeletePyqPdf"
                                                          ? (deleteDataName =
                                                              data?.batchName)
                                                          : pagename ===
                                                              "EditDeleteResults"
                                                            ? (deleteDataName =
                                                                data?.studentName)
                                                            : pagename ===
                                                                "seoSubExam"
                                                              ? (deleteDataName =
                                                                  data?.metaTitle)
                                                              : pagename ===
                                                                  "courseFAQ"
                                                                ? (deleteDataName =
                                                                    data?.question)
                                                                : pagename ===
                                                                    "productSchema"
                                                                  ? (deleteDataName =
                                                                      data?.CourseName)
                                                                  : pagename ===
                                                                      "examDetails"
                                                                    ? (deleteDataName =
                                                                        data?.heading)
                                                                    : pagename ===
                                                                        "classroomBatch"
                                                                      ? (deleteDataName =
                                                                          moment
                                                                            .utc(
                                                                              data?.date,
                                                                            )
                                                                            .format(
                                                                              "LL",
                                                                            ))
                                                                      : pagename ===
                                                                            "editQuestion" ||
                                                                          pagename ===
                                                                            "editQuestionBank" ||
                                                                          pagename ===
                                                                            "questionOftheDay"
                                                                        ? (deleteDataName =
                                                                            data
                                                                              ?.en
                                                                              .title[0]
                                                                              .description)
                                                                        : pagename ===
                                                                            "coupon"
                                                                          ? (deleteDataName = `${data?.examTypeId?.name} - ${data?.baseCourseId?.name}`)
                                                                          : pagename ===
                                                                              "configQuestion"
                                                                            ? (deleteDataName = `${data?.examType?.name} - ${data?.baseCourse?.name}`)
                                                                            : pagename ===
                                                                                  "examMapping" ||
                                                                                pagename ===
                                                                                  "departmentMapping"
                                                                              ? (deleteDataName = `${data?.toExamTypeName} - ${data?.toBaseCourseName}`)
                                                                              : pagename ===
                                                                                  "srcVideoData"
                                                                                ? (deleteDataName =
                                                                                    "Video")
                                                                                : pagename ===
                                                                                    "deviceCompany"
                                                                                  ? (deleteDataName = `${data?.name}`)
                                                                                  : pagename ===
                                                                                      "deviceModel"
                                                                                    ? (deleteDataName = `${data?.name}`)
                                                                                    : pagename ===
                                                                                        "facebookGroupList"
                                                                                      ? (deleteDataName = `${data?.groupName}`)
                                                                                      : pagename ===
                                                                                          "CreatePublicationVendor"
                                                                                        ? (deleteDataName = `${data?.companyName}`)
                                                                                        : (deleteDataName =
                                                                                            "");
                                  }

                                  setDeleteData({
                                    ...data,
                                    deleteDataName,
                                  });
                                }}
                              >
                                {" "}
                                Delete
                              </span>
                            ) : null}
                            {pagename === "serverList" ? (
                              data?.instanceState === "RUNNING" ? (
                                <span
                                  type="submit"
                                  className="btn btn-danger rounded me-2 fw-bold cursor"
                                  onClick={() => handleStatus(data)}
                                >
                                  STOP
                                </span>
                              ) : data?.instanceState === "STOPPED" ? (
                                <span
                                  type="submit"
                                  className="btn btn-primary border rounded me-2 fw-bold cursor"
                                  onClick={() => handleStatus(data)}
                                >
                                  START
                                </span>
                              ) : data?.instanceState === "PENDING" ||
                                data?.instanceState === "STOPPING" ? (
                                <span
                                  type="submit"
                                  className="btn btn-secondary border rounded me-2 fw-bold cursor"
                                  disabled={true}
                                >
                                  WAIT
                                </span>
                              ) : null
                            ) : null}
                          </>
                        )}
                      </td>
                    )}
                  </tr>
                  {/* {pagename === "EditDeleteTeacherTasks" ? (
                    <tr>
                      {data?.remarkBy ? (
                        <td colSpan={9}>
                          <div className="align-items-center">
                            <div className="d-flex">
                              <div className="fw-bold me-2">Remark : </div>
                              <span> {data?.remark}</span>
                            </div>
                            <div className="d-flex">
                              <div className="fw-bold me-2">Remark By: </div>
                              <div>{data?.remarkBy}</div>
                            </div>
                          </div>
                        </td>
                      ) : (
                        <td>-</td>
                      )}
                    </tr>
                  ) : null} */}
                  {pagename === "liveRecVideoLectList" ? (
                    <tr>
                      {data?.courseId ? (
                        <td colSpan={9}>
                          <div className="d-flex align-items-center">
                            <div className="fw-bold">Batch Name : </div>
                            <div>{getSessions(data?.courseId)}</div>
                            {pagename === "liveRecVideoLectList" ? (
                              <span
                                type="submit"
                                className="text-primary fw-bold me-2 cursor"
                                onClick={() =>
                                  handleEditBatch(data?.courseId, data?._id)
                                }
                              >
                                Edit
                              </span>
                            ) : null}
                          </div>
                        </td>
                      ) : (
                        <td>-</td>
                      )}
                    </tr>
                  ) : null}
                  {pagename === "editFreePremierVideo" &&
                  (type === 1 || type === 2) ? (
                    <tr>
                      {data?.coursesData ? (
                        <td colSpan={9}>
                          <div className="d-flex align-items-center">
                            <div className="fw-bold">Batch Name : </div>
                            <div>{getBatchNames(data?.coursesData)}</div>
                            {pagename === "editFreePremierVideo" ? (
                              <span
                                type="submit"
                                className="text-primary fw-bold me-2 cursor"
                                onClick={() =>
                                  handleEditBatch(data?.coursesData, data?._id)
                                }
                              >
                                Edit
                              </span>
                            ) : null}
                          </div>
                        </td>
                      ) : (
                        <td>-</td>
                      )}
                    </tr>
                  ) : null}

                  {pagename === "editLiveVideo" ||
                  (pagename === "editLivePremierVideo" &&
                    (type === 1 || type === 2)) ? (
                    <tr>
                      {data?.courseId ? (
                        <td colSpan={9}>
                          <div className="d-flex align-items-center">
                            <div className="fw-bold">Batch Name : </div>
                            <div>{getBatchNames(data?.courseId)}</div>
                            {pagename === "editLiveVideo" ||
                            pagename === "editLivePremierVideo" ? (
                              <span
                                type="submit"
                                className="text-primary fw-bold me-2 cursor"
                                onClick={() =>
                                  handleEditBatch(data?.courseId, data?._id)
                                }
                              >
                                Edit
                              </span>
                            ) : null}
                          </div>
                        </td>
                      ) : (
                        <td>-</td>
                      )}
                    </tr>
                  ) : null}

                  {pagename === "editLivePremierVideo" ||
                  pagename === "editLiveFreeVideo" ||
                  pagename === "courseId" ? (
                    <tr>
                      {data?.classSchedule ? (
                        <td colSpan={9}>
                          <div className="d-flex align-items-center">
                            <div className="fw-bold">Class Date: </div>
                            <div>{getBatchNames(data?.classSchedule)}</div>
                          </div>
                        </td>
                      ) : (
                        <td>-</td>
                      )}
                    </tr>
                  ) : null}
                </>
              );
            })
          ) : (
            <tr>
              <td>No record found.</td>
            </tr>
          )}
        </tbody>
      </table>
      <DeletePopup
        open={deletePopup}
        handleClose={() => setDeletePopup(false)}
        handleSubmit={() => {
          handleDelete(deleteData);
          setDeletePopup(false);
        }}
        pagename={pagename}
        data={deleteData.deleteDataName}
      />
    </div>
  );
}

export default AdminTable;
